import { fabric } from "fabric";
import { AppIsStreaming, getUserDetailsById, isLocalUserStreaming } from "../../components/Twilio/Room/roomFunction";
import CustomToast from "../../components/UI/customToast";
import reduxStore from "../../configureEnvStore";
import {
    AGENT_DEFAULT_COLOR,
    AR_MARKUP_VIEW,
    COLOR_TO_ANNOT,
    DEVICE_TYPES,
    ENABLED,
    FONT_SIZE,
    KEYBOARD_KEYS,
    MARKUP_VIEW,
    MAX_CHUNK_SIZE,
    SHAPE_THICKNESS,
    SHAPE_TYPE,
    shapeStatus,
} from "../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { EVENT_NAME } from "../../constants/GTagConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { STATUS } from "../../constants/LivePointerConstants";
import Localize from "../../locale/Localize";
import { setOppoDetails } from "../../reducers/common-reducer";
import {
    setAllShapeDisable,
    setAnnPointlength,
    setARmarkupLiveStream,
    setARMarkupToastMsgStatus,
    setAssignedColors,
    setCallannview,
    setConfirmExitMarkup,
    setContinueMarkup,
    setIsShadowOrStroke,
    setMarkupInprogress,
    setMarkupLiveStream,
    setRedoEnabled,
    setSavebtndisabled,
    setSelectedColorIndex,
    setSelectedFontSizeForShape,
    setSelectedShapeType,
    setSelectedThicknessForShape,
    setUndoEnabled,
} from "../../reducers/markup-reducer";
import extractTextService from "../extractTextService";
import { LogFirebase } from "../firestore";
import googleEvent from "../googleEvent";
import navigatorService from "../navigatorService";
import takePhotoService from "../takePhotoService";
import zoomService from "../zoomService";
import { dualStreamEnabled } from "../../shared/utility";
import { performStartStopVideo } from "../../components/Twilio/VideoCall/VideoUtils";
import { isEmpty } from "lodash";
import {
    disableMarkupRedo,
    disableMarkupUndo,
    enableMarkupRedo,
    enableMarkupUndo,
    enableSaveMarkup,
    generateArrow,
    generateRectangle,
    generateTextbox,
    minimumArrowSize,
    showShadow,
} from "../../components/Markup/MarkupFunction";
import { DECREASE, INCREASE, MarkupLargeTextSize, MarkupTextSize, MaximumCharForText, MaximumCharInOneLine } from "../../constants/MarkupConstants";
import watermarkImageService from "../WatermarkImage/watermarkImageService";
import { setDownloadImageFailed, setShowOrientationModal } from "../../reducers/extractText-reducer";
import { checkPublishVideoOnExit, sendDataTrack, sendMsgForPointer } from "../../shared/dataTrackFunction";
import { SELECTED_SCREEN } from "../../constants/UploadFilesConstants";
import arMarkupService from "./arMarkupService";
import { attachVideoTracksStreamingIdentityVise } from "../../components/GalleryView/GalleryViewUtils";

// Use lazy require to avoid circular dependency with livePointerService
const getLivePointerService = () => require("../../components/LivePointer/livePointerService").default;

class MarkupService {
    annCanvas = false;
    annotedfile = null;
    annImgURL = null;
    markupOrientation = 0;
    savebtndisabled = false;
    dataTrackStatus = {
        uploadImageStart: "1",
        uploadImageComplete: "2",
        stopMarkup: "5",
        clearMarkup: "6",
        cancleMarkup: "7",
        uploadImageFail: "8",
        saveImageStarted: "10",
        saveFromAndroidApp: "11",
        appRunningInbackground: "12",
        appRunningInForeground: "13",
    };

    annCanvasProperty = {
        width: 0,
        height: 0,
    };

    canvasBound = {
        1: false,
        2: false,
        3: false,
        4: false,
        6: false,
    };
    iscirlce = false;
    isresetted = false;
    allShapeDisable = false;
    freeway = false;
    freeDrawPoints = [];
    // for rect
    rect = null;
    isDrawingRect = false;
    isMovingRect = false;

    //for blur
    blur = null;
    isDrawingBlur = false;
    isMovingBlur = false;

    //for text
    MarkupDefaultText = null;
    isDrawingArrow = false;
    isMovingArrow = false;
    isMovingText = false;
    arrowObj = null;
    textbox = null;
    origX = null;
    origY = null;
    pointer = null;
    newLineAdded = false;
    currTimeStamp = null;

    shape = SHAPE_TYPE.FREEDRAW;
    canvasObjLength = 0;
    localShapesList = []; // list of all the objects
    localUndoList = []; //list of objects which are undone
    remoteUndoList = []; //all the objects which are undo by remote users
    shapeTextObj = { 1: "FREEDRAW", 2: "RECT", 3: "TEXT", 4: "CIRCLE", 5: "MASK", 6: "ARROW" };
    freedrwcnt = 0;
    startpointx = null;
    startpointy = null;
    xyPosVal = [];
    isDragging = false;
    numberOfCountForARMarkupArrow = 0; // number of count for AR MarkUP Arrow

    // save Image
    uploadingCount = 0;
    uploadedCount = 0;
    saveImageToastId = 5;
    fromEndCall = false;

    isMarkupInProgress = (markupInprogress) => {
        return markupInprogress === MARKUP_VIEW.PREPARE_VIEW || markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW;
    };

    handleFailedStreaming = (fromWhere) => {
        reduxStore.dispatch(setMarkupLiveStream(false));
        reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.OFF_VIEW));
        extractTextService.checkUploadTimeout();
        this.sendStartMarkupMessage(fromWhere);
    };

    handleSuccessfulStreaming = (fromWhere) => {
        this.markupOrientation = navigatorService.getOrientation();

        if (fromWhere === "ARMarkup") {
            const arMarkupState = reduxStore.getState().markup.arMarkupLiveStream;
            if (arMarkupState === AR_MARKUP_VIEW.OFF_VIEW) {
                reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.PREPARE_VIEW));
            }
            this.sendStartMarkupMessage(fromWhere);
        } else {
            reduxStore.dispatch(setMarkupLiveStream(true));
            this.sendStartMarkupMessage("LiveMarkup");
        }
    };

    startHDCapture = (fromWhere) => {
        if (fromWhere == "ARMarkup" && GLOBAL_MEETING_DATA.isGuest) {
            // do nothing
        } else {
            reduxStore.dispatch(setSelectedColorIndex(0)); // set agent color Index
        }

        const markupInprogress = reduxStore.getState().markup.markupInprogress;
        if (!this.isMarkupInProgress(markupInprogress)) {
            if (isLocalUserStreaming()) {
                console.log("capture screen");
                this.startMyScreenForMarkup(false, true); //// old-startmyscreennew
                this.sendStartMarkupMessage(fromWhere);
            } else {
                AppIsStreaming(fromWhere).then(
                    () => this.handleSuccessfulStreaming(fromWhere),
                    () => this.handleFailedStreaming(fromWhere)
                );
            }
        } else {
            CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["markup_is_in_progress"]);
        }
    };

    startMyScreenForMarkup = () => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;

        extractTextService.closeAllModel();

        this.resetLocalShapesList();

        CALL_DATA.myscreenShareON = Boolean(reduxStore.getState().twilioEvents.isLocalUserScreenSharing);
        CALL_DATA.myVideoON = Boolean(startLocalVideo);

        this.markupOrientation = navigatorService.getOrientation();

        if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
            LogFirebase("Markup", "current_orientation", this.markupOrientation);
        }

        // send message for uploading image
        let msg = {
            notification_type: NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT,
            identity: CALL_DATA.localIdentity,
            status: this.dataTrackStatus.uploadImageStart,
            device_type: GLOBAL_MEETING_DATA.device_type,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };
        sendDataTrack(msg);
        LogFirebase("Markup", "send_msg_image_uploading_status", "UPLOADING");
        console.log("start screen");
        let width;
        let height;
        let video;
        video = document.querySelector("#expandedVideo video");
        if (video != undefined && video != null && video != "" && video.videoWidth != 0 && video.videoHeight != 0) {
            width = video.videoWidth;
            height = video.videoHeight;
            if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                LogFirebase("Markup", "videoConstraints", { height: height, width: width });
            }
        } else {
            LogFirebase("Markup", "video_element_not_found", "");
        }
        takePhotoService.imageCaptureForTakePhotoMarkupOCRCanvas("Markup", video, width, height);
    };

    sendStartMarkupMessage = (fromWhere) => {
        if (fromWhere === "ARMarkup" || fromWhere === "LiveMarkup") {
            // do nothing
        } else {
            extractTextService.onStartPrepareView("Markup");
        }

        googleEvent.logEvent(EVENT_NAME.STARTED_MARKUP);
        extractTextService.closeAllModel();
        if (fromWhere == "ARMarkup") {
            // do nothing
        } else {
            this.sendStartMarkupMessageForAssignColor();
        }
        /* For ARmarkup */
        if (reduxStore.getState().markup.markupLiveStream || arMarkupService.checkARMarkupIsOngoing()) {
            this.startMarkupLiveStream();
        }
    };

    setCanvasForMarkup = (img) => {
        this.annCanvasProperty.width = img.width;
        this.annCanvasProperty.height = img.height;
        this.annCanvas = new fabric.Canvas("markup-outer-canvas");
        this.annCanvas.isDrawingMode = false;
        let oImg = null;
        if (img.width < 950) {
            // we don't touch  this as it is for video resolution
            this.annCanvas.setWidth(img.width);
            this.annCanvas.setHeight(img.height < 600 ? img.height : "600");
            oImg = img.set({
                width: img.width,
                centeredRotation: true,
                centeredScaling: true,
            });
        } else {
            oImg = img.set({
                centeredRotation: true,
                centeredScaling: true,
                backgroundImageStretch: false,
            });
            oImg = img.scaleToWidth(img.width); // for the fix of screenshare resolution is low we removed 950 width scale
        }
        this.annCanvas.setWidth(img.width * oImg.scaleX);
        document.querySelector(".canvas-container").classList.add("custom-canvas-container");
        document.querySelector(".lower-canvas").classList.add("custom-lower-canvas");
        document.querySelector(".upper-canvas").classList.add("custom-upper-canvas");
        this.annCanvas.setHeight(img.height * oImg.scaleY);

        this.annCanvas.setBackgroundImage(oImg).renderAll();
        this.annCanvas.selection = false;
    };

    renderImageForMarkup = (canfile1, doNotUnpulishVideo) => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;
        this.annotedfile = canfile1;
        const reader = new FileReader();
        reader.onload = (f) => {
            let data = f.target.result;
            fabric.Image.fromURL(data, (img) => {
                console.log(img);
                this.setCanvasForMarkup(img);
                extractTextService.onExitPrepareView(false);
                reduxStore.dispatch(setCallannview(true));

                if (GLOBAL_MEETING_DATA.isGuest) {
                    // on reconnect reset the thickness
                    reduxStore.dispatch(setSelectedThicknessForShape(SHAPE_THICKNESS[5])); // 10px
                    reduxStore.dispatch(setSelectedFontSizeForShape(FONT_SIZE[7])); // 30px
                }
                reduxStore.dispatch(setIsShadowOrStroke(true)); // default shadow is on
                this.selectCurrentDrawing(SHAPE_TYPE.FREEDRAW);

                if (reduxStore.getState().markup.markupInprogress !== MARKUP_VIEW.START_MARKUP_VIEW) {
                    reduxStore.dispatch(setMarkupInprogress(MARKUP_VIEW.START_MARKUP_VIEW));
                }

                if (!doNotUnpulishVideo && !dualStreamEnabled() && startLocalVideo) {
                    // do not unpublish video when function call for opponent screen & if in multi stream
                    // Unpublish video before starting OCR to save bandwidth
                    performStartStopVideo();
                }
            });
        };
        reader.readAsDataURL(canfile1);
        clearTimeout(extractTextService.clearCheckUploadTimeout);
        extractTextService.clearCheckUploadTimeout = null;
    };

    sendStartMarkupMessageForAssignColor = () => {
        let colorsToDraw = {};
        reduxStore.getState().twilioEvents?.participantIdentities?.forEach((val, key) => {
            colorsToDraw[val] = COLOR_TO_ANNOT[key + 1];
        });
        reduxStore.dispatch(setAssignedColors(colorsToDraw));
        let msg = {
            identity: CALL_DATA.localIdentity,
            colors: colorsToDraw,
            total_remote_participations: reduxStore.getState().twilioEvents.participantIdentities?.length,
        };
        if (reduxStore.getState().markup.markupLiveStream) {
            //markup on live stream
            msg.notification_type = NOTIFICATION_TYPES.MARKUP_LIVESTREAM.AGENT_TO_ALL; // do it constant when ARmarkup start
            LogFirebase("Markup", "LiveStream-send_msg", "Start Markup");
        } else if (arMarkupService.checkARMarkupIsOngoing()) {
            // do nothing
        } else {
            //markup on image
            msg.notification_type = NOTIFICATION_TYPES.MARKUP.AGENT_TO_ALL;
            LogFirebase("Markup", "send_msg", "Start Markup");
        }
        if (msg) {
            if (arMarkupService.checkARMarkupIsOngoing()) {
                // do nothing
            } else {
                sendDataTrack(msg);
            }
        }
    };

    /* Handle 503 datatrack */
    handleMarkupRequestToStreamingUser = (message) => {
        if (PublicVariables.featureFlag?.SHOWMELIVEANNOTATION === ENABLED) {
            LogFirebase("Markup", "received_msg_start_markup", "Agent Started Markup");
            // 503 - start markup
            if (PublicVariables.isMobile) {
                zoomService.disablepinchOnmarkup = true; // to check mark up is on
                zoomService.disablePinchZoom(); // disable pinch zoom
            }
            this.setAnnoteColor(message);
            if (isLocalUserStreaming()) {
                extractTextService.onStartPrepareView("Markup");
                this.startMyScreenForMarkup(true, true);
            }
        }
    };

    setAnnoteColor = (message, fromWhere) => {
        let id = CALL_DATA.localIdentity;
        let anncolor;
        if (message.for_new_joinee != null && message.for_new_joinee != undefined && message.for_new_joinee != "") {
            // to decide color for new joinee

            if (fromWhere == "ARMarkup") {
                const colorsArray = message.colors;
                if (colorsArray[id] != undefined && colorsArray[id] != null && colorsArray[id] != "") {
                    anncolor = colorsArray[id];
                }
            } else {
                if (message.for_new_joinee[id] != undefined && message.for_new_joinee[id] != null && message.for_new_joinee[id] != "") {
                    anncolor = message.for_new_joinee[id];
                }
            }
        } else {
            const colorsArray = message.colors;
            if (colorsArray[id] != undefined && colorsArray[id] != null && colorsArray[id] != "") {
                anncolor = colorsArray[id];
            }
        }

        if (anncolor) {
            const index = COLOR_TO_ANNOT.indexOf(anncolor);
            reduxStore.dispatch(setSelectedColorIndex(index));
            const radioButton = document.querySelector(`input[name='colorpickerFile'][value='${index}']`);
            if (radioButton) {
                radioButton.checked = true;
            }
        }
    };

    /* for streaming user - Handle 504 datatrack */
    handleMarkupRequestFromStreamingUser = (msg) => {
        if (PublicVariables.featureFlag?.SHOWMELIVEANNOTATION !== ENABLED) {
            return;
        }
        if (msg.identity !== CALL_DATA.localIdentity) {
            const { dataTrackStatus } = this;
            switch (msg.status) {
                case dataTrackStatus.uploadImageStart: // capture image inprogress
                    LogFirebase("Markup", "received_msg_image_uploading_status", "UPLOADING");
                    // capture image inprogress
                    extractTextService.onStartPrepareView("Markup");
                    if (GLOBAL_MEETING_DATA.isGuest) {
                        //when agent is streaming
                        extractTextService.checkUploadTimeout("Markup");
                    }
                    break;
                case dataTrackStatus.uploadImageComplete: // image uploaded, ready to download
                    // image uploaded , ready to download
                    LogFirebase("Markup", "received_msg_image_uploading_status", "UPLOADED");
                    this.annImgURL = msg.image_url;
                    console.log("remote part ===>", msg);
                    reduxStore.dispatch(
                        setOppoDetails({
                            deviceType: msg.device_type,
                            oppOrientation: msg.orientation,
                            lat: msg.lat,
                            long: msg.long,
                        })
                    );
                    extractTextService.onStartPrepareView("Markup");
                    // for new joinee in a call - if markup is ongoing will start markup directly - TO DO
                    if (msg.for_new_joinee != null && msg.for_new_joinee != undefined && msg.for_new_joinee != "") {
                        const id = msg.for_new_joinee[CALL_DATA.localIdentity];
                        if (id != null && id != undefined && id != "") {
                            CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["joining_image_markup"]);
                            this.setAnnoteColor(msg);
                            this.startOppoScreen(msg);
                        }
                    } else {
                        this.startOppoScreen(msg);
                    }
                    break;
                case dataTrackStatus.stopMarkup: // stop markup
                    LogFirebase("Markup", "received_msg_stopped_markup", "Markup stopped by " + msg.identity);
                    zoomService.disablepinchOnmarkup = false;
                    if (reduxStore.getState().markup.callannview) {
                        if (GLOBAL_MEETING_DATA.isAgent) {
                            this.checkConfirmOrExitMarkup();
                            extractTextService.showExitMarkUpOCRToast("Markup", msg.identity);
                        } else {
                            extractTextService.onExitPrepareView(true);
                            this.toggleannotationdiv(true, false, true);
                            CustomToast.info(Localize[PublicVariables.currentLanguageObj?.languageCode]["image_marking_stopped"]);
                        }
                    } else {
                        //do not perform anything
                    }
                    break;
                case dataTrackStatus.clearMarkup: // clear markup image
                    console.log("clear markup from notification");
                    LogFirebase("Markup", "received_msg_clear", "Markup cleared clicked by " + msg.identity);
                    this.clearImg(false); // clear all is not clicked and coming from notification then don't send msg to any other user
                    break;
                case dataTrackStatus.cancleMarkup: //request to cancel markup
                    extractTextService.cancelMarkUpOCRPreparing("Markup");
                    break;
                case dataTrackStatus.uploadImageFail: //image to perform the markup - upload failed
                    extractTextService.hideMarkupOCRAndShowMsg("Markup", msg.body);
                    break;
                default:
                    console.log("default case");
                    break;
            }
        }
    };

    checkConfirmOrExitMarkup = () => {
        if (PublicVariables.featureFlag.SHOWMESAVEMARKUP == ENABLED && !reduxStore.getState().markup.savebtndisabled) {
            reduxStore.dispatch(setContinueMarkup(false));
            reduxStore.dispatch(setConfirmExitMarkup(true));
        } else {
            extractTextService.onExitPrepareView(true);
            this.toggleannotationdiv(true, false, true);
        }
    };

    /**when markup live stream is ON, send message to android app for save marked up image */
    sendSaveMarkupLiveStreamMsg = () => {
        let msg = {
            status: this.dataTrackStatus.saveImageStarted,
            device_type: GLOBAL_MEETING_DATA.device_type,
            identity: CALL_DATA.localIdentity,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };
        if (reduxStore.getState().markup.markupLiveStream) {
            msg.notification_type = NOTIFICATION_TYPES.MARKUP_LIVESTREAM.GUEST_TO_AGENT;
        } else if (arMarkupService.checkARMarkupIsOngoing()) {
            msg.notification_type = NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT;
        }
        LogFirebase("Markup", "LiveStream-send_msg", "Save Markup");
        sendDataTrack(msg);
    };

    uploadMarkupImage = (imageData) => {
        let blob = watermarkImageService.__base64ToBlobImage.convertData(imageData);
        //send request to backend with form data
        takePhotoService.uploadImage("markup", blob, null, (response) => {
            let result = response.data;
            if (response.success > 0) {
                console.log("markup upload success");
                this.uploadedCount = parseInt(this.uploadedCount) + 1;
                takePhotoService.addThumbInList(result.thumbUrl, result.fileUrl, result.fileName);
                if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                    LogFirebase("Markup", "saved_by_agent", "Markup UPLOADED::" + result.fileUrl);
                } else {
                    LogFirebase("Markup", "saved_by_agent", "Markup UPLOADED");
                }
                extractTextService.showToastMessage(
                    Localize[PublicVariables.currentLanguageObj?.languageCode]["uploading_image"] +
                        " " +
                        "(" +
                        (this.uploadedCount + 1) +
                        "/" +
                        this.uploadingCount +
                        ")",
                    true,
                    this.saveImageToastId
                );
                if (this.uploadedCount == this.uploadingCount) {
                    this.uploadingCount = 0;
                    this.uploadedCount = 0;
                    extractTextService.showToastMessage(
                        Localize[PublicVariables.currentLanguageObj?.languageCode]["successfully_uploaded"],
                        false,
                        this.saveImageToastId
                    );

                    setTimeout(() => {
                        extractTextService.dismissAgentToast(this.saveImageToastId);
                    }, 2000);
                }
            } else {
                this.uploadingCount = this.uploadingCount - 1;
                extractTextService.dismissAgentToast(this.saveImageToastId);
                CustomToast.error(Localize[PublicVariables.currentLanguageObj?.languageCode]["upload_failed"]);
                LogFirebase("Markup", "saved_by_agent", "Markup UPLOAD FAILED");
            }
        });
    };

    saveImageWithLiveStreamHandler = () => {
        reduxStore.dispatch(setSavebtndisabled(true));
        this.uploadingCount = this.uploadingCount + 1;
        extractTextService.showToastMessage(
            Localize[PublicVariables.currentLanguageObj?.languageCode]["uploading_image"] +
                " " +
                "(" +
                (this.uploadedCount + 1) +
                "/" +
                this.uploadingCount +
                ")",
            true,
            this.saveImageToastId
        );
        this.sendSaveMarkupLiveStreamMsg();
    };

    saveImageWithoutLiveStreamHandler = () => {
        //if current selected shape is text check for placehodler and remove
        if (this.shape != null && this.shape == SHAPE_TYPE.TEXT) {
            this.checkTextPlaceholder();
        }
        LogFirebase("Markup", "saved_clicked", "Agent uploading Marked up image");
        reduxStore.dispatch(setSavebtndisabled(true));
        this.uploadingCount = this.uploadingCount + 1;
        extractTextService.showToastMessage(
            Localize[PublicVariables.currentLanguageObj?.languageCode]["uploading_image"] +
                " " +
                "(" +
                (this.uploadedCount + 1) +
                "/" +
                this.uploadingCount +
                ")",
            true,
            this.saveImageToastId
        );
        reduxStore.dispatch(setAnnPointlength(this.canvasObjLength));

        let imageWidth = this.annCanvasProperty.width;
        let imageHeight = this.annCanvasProperty.height;
        console.log("height " + imageHeight + "width  " + imageWidth);

        // convert canvas to image
        let mainImage = new Image();
        // for fix the blurry image during save image use multiplier
        // remove mulitiplier after scale code remove in markup canvas for 950
        mainImage.src = this.annCanvas.toDataURL("png");
        mainImage.onload = () => {
            let svgImg = new Image();
            const deviceOrientation = navigatorService.getOrientation();
            let objVal = watermarkImageService.__watermarkImage.fetchImageWaterMark({
                screenType: "markup",
                width: imageWidth,
                height: imageHeight,
                localOrientation: deviceOrientation,
                bookmark: false,
                liveLat: false,
                liveLong: false,
                localSS: CALL_DATA.myscreenShareON,
                localVideo: CALL_DATA.myVideoON,
            });
            const { imageSrc, canvasHeight } = objVal;
            svgImg.src = imageSrc;

            let canvas = document.getElementById("screenshotcanvas");
            let context = canvas.getContext("2d");
            if (imageWidth && imageHeight) {
                canvas.width = imageWidth;
                canvas.height = canvasHeight;
                context.drawImage(mainImage, 0, 0, imageWidth, imageHeight);
                svgImg.onload = () => {
                    context.drawImage(svgImg, 0, 0);
                    let imageData = canvas.toDataURL("image/jpeg", 1.0);
                    this.uploadMarkupImage(imageData);
                };
            }
        };
        // END -- convert canvas to image
    };

    sendStopMarkupMsgHandler = (isMarkupLiveStream, isARmarkupLiveStream) => {
        let message = {
            status: this.dataTrackStatus.stopMarkup,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };

        if (isMarkupLiveStream) {
            message.notification_type = NOTIFICATION_TYPES.MARKUP_LIVESTREAM.GUEST_TO_AGENT;
            LogFirebase("Markup", "LiveStream-send_msg", "Exit Markup");
        } else if (isARmarkupLiveStream) {
            message.notification_type = NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT;
            LogFirebase("Markup", "LiveStream-send_msg", "Exit Markup");
        } else {
            message.notification_type = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT;
            LogFirebase("Markup", "send_msg", "Exit Markup");
        }
        sendDataTrack(message);
    };

    setDefaultShape = () => {
        this.shape = SHAPE_TYPE.FREEDRAW;
        reduxStore.dispatch(setSelectedShapeType(SHAPE_TYPE.FREEDRAW));
    };

    /**on exit markup unset markup livestream  */
    unsetMarkupLiveStream = () => {
        this.addRemoveMarkUpBodyCss(false);
        //// utility.showLatLongView();

        reduxStore.dispatch(setMarkupLiveStream(false));
        reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.OFF_VIEW));
        reduxStore.dispatch(setARMarkupToastMsgStatus(null));
        //// $("#outcanvas_container").attr("class","");
        //// if($rootScope.selectedResolutionKey != Constants.HDResolution){
        ////     $('body').removeClass("video_auto_width");
        //// }
        //// if($scope.isUploading){
        ////     $scope.isUploading = false;
        ////     $scope.uploadstatus = '';
        //// }
    };

    // in mweb font and thickness dropdown is not closing while clicking outside
    closeMarkupDropdown = () => {
        const thicknessElement = document.getElementById("markup-thickness-dropdown");
        if (thicknessElement?.classList.contains("show")) {
            thicknessElement.classList.remove("show");
        }
        const fontElement = document.getElementById("markup-fonts-dropdown");
        if (fontElement?.classList.contains("show")) {
            fontElement.classList.remove("show");
        }
        const markupDropdown = document.querySelector(".markup-common-dropdown-menu");
        if (markupDropdown?.classList.contains("show")) {
            markupDropdown.classList.remove("show");
        }
        const colorFillElement = document.getElementById("colorfill");
        if (colorFillElement?.classList.contains("show")) {
            colorFillElement.classList.remove("show");
        }
        const colorPickerElement = document.getElementById("color-picker-dropdown");
        if (colorPickerElement?.classList.contains("show")) {
            colorPickerElement.classList.remove("show");
        }
    };

    disposeAnnCanvas = () => {
        const canvasContainer = document.querySelector(".canvas-container");
        if (canvasContainer) canvasContainer.classList.remove("custom-canvas-container");
        //// $('.customizer').removeClass('customizer-active');
        const firstLowerCanvas = document.querySelector(".lower-canvas");
        if (firstLowerCanvas) firstLowerCanvas.classList.remove("custom-lower-canvas");
        const firstUpperCanvas = document.querySelector(".upper-canvas");
        if (firstUpperCanvas) firstUpperCanvas.classList.remove("custom-upper-canvas");

        console.log("this.annCanvas", this.annCanvas);

        if (this.annCanvas) {
            LogFirebase("Markup", "canvas_removed", "Markup canvas removed");

            if (PublicVariables.isMobile) {
                let obj = this.annCanvas.getActiveObject();
                if (obj?.shape_type != undefined && obj.shape_type === SHAPE_TYPE.TEXT) {
                    obj.exitEditing(); //to close the opened keypad in mweb
                }
            }
            this.annCanvas.dispose();
        }

        const markupCanvasEle = document.getElementById("markup-outer-canvas");
        if (markupCanvasEle) markupCanvasEle.style.display = "none";
        // Find its sibling with the class 'upper-canvas' and remove it
        let upperCanvasSibling = markupCanvasEle?.nextElementSibling;
        if (upperCanvasSibling?.classList.contains("upper-canvas")) {
            upperCanvasSibling.remove();
        }
    };

    removeCanvasHandler = () => {
        extractTextService.onExitPrepareView(true);
        this.setDefaultShape();
        this.allShapeDisable = false;
        reduxStore.dispatch(setAllShapeDisable(false));
        this.resetCanvasBound();
        this.resetLocalShapesList();
        reduxStore.dispatch(setSavebtndisabled(true));
        reduxStore.dispatch(setCallannview(false));
        reduxStore.dispatch(setShowOrientationModal(false));

        this.disposeAnnCanvas();

        reduxStore.dispatch(setConfirmExitMarkup(false));
        reduxStore.dispatch(setMarkupInprogress(MARKUP_VIEW.OFF_VIEW));
        //// if upload view is true on exit markup, then do not show video screen view (Show upload inprocess view)
        ////   if ($scope.fromEndCall == false && $rootScope.uploadFilesView) {
        ////     $("#videoScreenShareContainer").css("display","none");
        //// }

        // to unpublish video before starting markup to save bandwidth
        if (!this.fromEndCall && reduxStore.getState().uploadFile.screenToShow === SELECTED_SCREEN.OFF_VIEW) {
            // do not publish video on markup exit, if upload view is ON.
            if (CALL_DATA.myVideoON && !dualStreamEnabled()) {
                checkPublishVideoOnExit();
            } else {
                setTimeout(() => {
                    attachVideoTracksStreamingIdentityVise();
                }, 1000);
            }
        }
        this.increaseDecreaseArrowCount(); // reset
        this.changeCanvasObjLength("reset");
        if (reduxStore.getState().markup.markupLiveStream) {
            this.unsetMarkupLiveStream();
        }
        if (arMarkupService.checkARMarkupIsOngoing()) {
            this.unsetMarkupLiveStream();
            arMarkupService.ARMarkupStopVariable("removeCanvas");
            arMarkupService.addRemoveARMarkupPointerBodyCss(false);
        }
        zoomService.resetZoomLevelOnExitView(); // Reset a Zoom level on exit Markup for only web devices (in dual stream(expanded view))
    };

    toggleannotationdiv = (fromNoti, saveimage, removeCanvas, fromCancel) => {
        const isMarkupLiveStream = reduxStore.getState().markup.markupLiveStream;
        const isARmarkupLiveStream = arMarkupService.checkARMarkupIsOngoing();

        if (saveimage && (isMarkupLiveStream || isARmarkupLiveStream)) {
            this.saveImageWithLiveStreamHandler();
        }

        if (saveimage && !isMarkupLiveStream && !isARmarkupLiveStream) {
            this.saveImageWithoutLiveStreamHandler();
        }

        if (removeCanvas) {
            this.removeCanvasHandler();
        }

        if (!fromNoti && !fromCancel && removeCanvas) {
            this.sendStopMarkupMsgHandler(isMarkupLiveStream, isARmarkupLiveStream);
        }

        // Handle live pointer after markup exit - wait for video to be ready instead of fixed timeout
        if (removeCanvas) {
            const livePointerService = getLivePointerService();

            LogFirebase("AutoLivePointer", "markup_exit_triggered", true);

            // Use video-ready detection instead of fixed 3000ms timeout
            livePointerService.waitForVideoReadyThenExecute(() => {
                //this should be run after 504 sent, as mobile apps will not have delegate registered on markup screen
                const { screenSharingUsers, videoStreamingUsers, isLocalUserScreenSharing, isOpponentUserScreenSharing } =
                    reduxStore.getState().twilioEvents;
                const isAnyVideoAvailable = !isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers);
                const hasLocalOrRemoteVideo = CALL_DATA.myVideoON || CALL_DATA.myscreenShareON || isAnyVideoAvailable;

                if (hasLocalOrRemoteVideo) {
                    sendMsgForPointer(STATUS.ENABLED); //send msg for mobile apps for pointer status

                    const { expandView } = reduxStore.getState().commonReducer;
                    const { pointerOn } = reduxStore.getState().livePointer;

                    // Dual stream handling - Agent only, on expand view
                    if (dualStreamEnabled() && GLOBAL_MEETING_DATA.isAgent && expandView && !pointerOn) {
                        LogFirebase("AutoLivePointer", "markup_exit_dual_stream_restart", { expandView, isAgent: true });
                        livePointerService.checkPointerStartOnMarkupOcrExitForDualStream();
                    }

                    // Single stream with screenshare - use auto pointer pattern
                    if (!dualStreamEnabled() && (isLocalUserScreenSharing || isOpponentUserScreenSharing)) {
                        LogFirebase("AutoLivePointer", "markup_exit_single_stream_screenshare", {
                            isLocalUserScreenSharing,
                            isOpponentUserScreenSharing,
                        });
                        if (pointerOn) {
                            livePointerService.turnOffLivePointer();
                        }
                        // Small delay to ensure pointer is fully turned off before restarting
                        // Note: autoPointerOnForSingleStream already sends ON data track, no need for sendDataTrackForStatusAuto
                        setTimeout(() => {
                            livePointerService.autoPointerOnForSingleStream();
                        }, 300);
                    }

                    // Single stream with video (local OR remote) - fallback auto-start
                    if (!dualStreamEnabled() && !isLocalUserScreenSharing && !isOpponentUserScreenSharing && isAnyVideoAvailable) {
                        LogFirebase("AutoLivePointer", "markup_exit_single_stream_video", { isAnyVideoAvailable });
                        livePointerService.autoStartLivePointerAfterMarkupOCR("after_markup_exit");
                    }
                } else {
                    LogFirebase("AutoLivePointer", "markup_exit_no_video_available", {
                        myVideoON: CALL_DATA.myVideoON,
                        myscreenShareON: CALL_DATA.myscreenShareON,
                        isAnyVideoAvailable,
                    });
                }
            });
        }
    };

    // download image and render image on canvas function
    startOppoScreen = (msg) => {
        const { markupInprogress } = reduxStore.getState().markup;
        //if prepare view exist or new user joins ongoing call
        if (markupInprogress === MARKUP_VIEW.PREPARE_VIEW || (!isEmpty(msg.for_new_joinee) && markupInprogress !== MARKUP_VIEW.START_MARKUP_VIEW)) {
            extractTextService.closeAllModel();
            this.resetLocalShapesList();
            let imgurl = msg.image_url;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", imgurl, true);
            xhr.send();
            xhr.responseType = "blob";
            this.markupOrientation = navigatorService.getOrientation();
            if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                LogFirebase("Markup", "current_orientation", this.markupOrientation);
            }
            xhr.onload = (_event) => {
                if (xhr.status === 200) {
                    console.log("success downloading ocr image");
                    LogFirebase("Markup", "image_downloading_status", "DOWNLOADED");
                    // blob format file in response
                    const blobfile1 = xhr.response;
                    let canfile1 = new File([blobfile1], "callimage.jpeg", { type: "image/jpeg" });
                    console.log(canfile1);
                    const markupCanvasEle = document.getElementById("markup-outer-canvas");
                    if (markupCanvasEle) markupCanvasEle.style.display = "block";
                    this.renderImageForMarkup(canfile1);
                }
            };
            // event triggered if download fails
            xhr.onerror = (e) => {
                // need to handle retry and download image pop up.
                LogFirebase("Markup", "image_downloading_status", "FAILED");
                reduxStore.dispatch(setDownloadImageFailed(true));
                console.log("Error " + e.target.status + " occurred while receiving the document.");
            };
        }
    };

    resetLocalShapesList = () => {
        reduxStore.dispatch(setUndoEnabled(false));
        reduxStore.dispatch(setRedoEnabled(false));
        this.localShapesList = [];
        this.remoteUndoList = [];
        this.localUndoList = [];
    };

    clearMarkupFlags = () => {
        this.resetLocalShapesList();
        this.resetlocalUndoList();
        this.increaseDecreaseArrowCount(); // reset arrow count
        this.changeCanvasObjLength("reset");
    };

    sendClearAllNotification = () => {
        let msg = {
            status: this.dataTrackStatus.clearMarkup,
            device_type: GLOBAL_MEETING_DATA.device_type,
            identity: CALL_DATA.localIdentity,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };
        if (reduxStore.getState().markup.markupLiveStream) {
            msg.notification_type = NOTIFICATION_TYPES.MARKUP_LIVESTREAM.GUEST_TO_AGENT;
            LogFirebase("Markup", "LiveStream-send_msg_clear", "Markup clear clicked by " + CALL_DATA.localIdentity);
        } else if (arMarkupService.checkARMarkupIsOngoing()) {
            msg.notification_type = NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT;
            LogFirebase("ARMarkup", "LiveStream-send_msg_clear", "Markup clear clicked by " + CALL_DATA.localIdentity);
        } else {
            msg.notification_type = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT;
            LogFirebase("Markup", "send_msg_clear", "Markup clear clicked by " + CALL_DATA.localIdentity);
        }
        sendDataTrack(msg);
        googleEvent.logEvent(EVENT_NAME.CLEARALL_TAPPED);
    };

    resetImageInCanvasAfterClearAll = (img) => {
        let canvas = document.createElement("canvas");
        canvas.id = "maincanvas";
        canvas.width = img.width;
        canvas.style.display = "none";
        canvas.height = img.height;
        canvas.style.width = img.width + "px";
        canvas.style.height = img.height + "px";
        canvas.style.position = "absolute";
        console.log("canvas", this.annCanvas);
        let oImg = null;
        if (img.width < 950) {
            // we don't touch  this as it is for video resolution
            this.annCanvas.setWidth(img.width);
            if (img.height < 600) {
                this.annCanvas.setHeight(img.height);
            } else {
                this.annCanvas.setHeight("600");
            }
            oImg = img.set({
                width: img.width,
                centeredRotation: true,
                centeredScaling: true,
            });
        } else {
            oImg = img
                .set({
                    centeredRotation: true,
                    centeredScaling: true,
                    backgroundImageStretch: false,
                })
                .scaleToWidth(img.width);
        }
        this.annCanvas.setWidth(img.width * oImg.scaleX);
        this.annCanvas.setHeight(img.height * oImg.scaleY);
        this.annCanvas.setBackgroundImage(oImg).renderAll();
    };

    clearImg = (clearAllClicked) => {
        // if clearAllClicked true then send notification msg to all other participants
        if (clearAllClicked) {
            this.sendClearAllNotification();
        }

        const toastMessage = arMarkupService.checkARMarkupIsOngoing()
            ? Localize[PublicVariables.currentLanguageObj.languageCode]["ar_markups_cleared_for_all_users"]
            : Localize[PublicVariables.currentLanguageObj.languageCode]["cleared_markup"];
        CustomToast.info(toastMessage);

        this.clearMarkupFlags();
        this.isresetted = true;
        if (this.annCanvas) {
            this.annCanvas.clear();
            this.annCanvas.discardActiveObject();
        }
        reduxStore.dispatch(setSavebtndisabled(true));
        if (!reduxStore.getState().markup.markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
            let reader = new FileReader();
            reader.onload = (f) => {
                let data = f.target.result;
                fabric.Image.fromURL(data, (img) => {
                    this.resetImageInCanvasAfterClearAll(img);
                });
            };
            reader.readAsDataURL(this.annotedfile);
        }
    };

    addRemoveMarkUpBodyCss = (add) => {
        let body = document.body;
        if (add) {
            body.classList.add("markup-livestream");
        } else {
            body.classList.remove("markup-livestream");
        }
    };

    /* Ar markup */
    startMarkupLiveStream = () => {
        let width;
        let height;
        let video;
        video = document.querySelector("#expandedVideo video");
        console.log("video--------------------", video);
        if (video != undefined && video != null && video != "" && video.videoWidth != 0 && video.videoHeight != 0) {
            width = video?.clientWidth;
            height = video?.clientHeight;
            if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                LogFirebase("Markup", "LiveStream-videoConstraints", { height: height, width: width });
            }
        } else {
            LogFirebase("Markup", "LiveStream-video_element_not_found", "");
        }
        console.log("width", width, "height", height);

        if (width && height) {
            setTimeout(() => {
                const canvas = document.getElementById("markup-outer-canvas");
                if (canvas) canvas.style.display = "block";
                this.annCanvas = new fabric.Canvas("markup-outer-canvas");
                this.annCanvas.isDrawingMode = false;
                this.annCanvas.setHeight(height);
                this.annCanvas.setWidth(width);
                this.annCanvas.selection = false;
                reduxStore.dispatch(setCallannview(true));
                this.selectCurrentDrawing(SHAPE_TYPE.FREEDRAW);
            }, 100);

            this.addRemoveMarkUpBodyCss(true);
            reduxStore.dispatch(setIsShadowOrStroke(true)); // default shadow is on
            return true;
        } else {
            return false;
        }
    };

    selectCurrentDrawing = (selectedShape) => {
        const currentShape = reduxStore.getState().markup.selectedShapeType;

        // Check if the user is not an observer
        if (!CALL_DATA.isObserver) {
            // If the current shape is text, perform additional checks
            if (currentShape !== null && currentShape === SHAPE_TYPE.TEXT) {
                this.checkTextPlaceholder();
            }

            // If no shape is selected or if a shape is selected
            // and the user is not an observer, update the selected shape type
            if (!selectedShape) {
                reduxStore.dispatch(setSelectedShapeType(SHAPE_TYPE.FREEDRAW));
            }
        }

        // Set the selected shape type in the Redux store
        reduxStore.dispatch(setSelectedShapeType(selectedShape));

        // Log the selected shape
        console.log(selectedShape);

        // Set the current shape
        this.shape = selectedShape;

        // Reset the local undo list
        this.resetlocalUndoList();

        // Perform actions based on the selected shape
        if (!CALL_DATA.isObserver) {
            switch (selectedShape) {
                case SHAPE_TYPE.FREEDRAW:
                    console.log("Selected shape: =====>", selectedShape);
                    if (!this.isCanvasBound(SHAPE_TYPE.FREEDRAW)) {
                        this.setCanvasBound(SHAPE_TYPE.FREEDRAW);
                        this.startFreeDrawing();
                    } else {
                        this.setFreeDrawingParam();
                    }
                    break;
                case SHAPE_TYPE.RECT:
                    console.log("Selected shape: =====>", selectedShape);
                    if (!this.isCanvasBound(SHAPE_TYPE.RECT)) {
                        this.setCanvasBound(SHAPE_TYPE.RECT);
                        this.drawRectangle();
                        LogFirebase("Markup", "select_rectangle", "");
                    }
                    break;
                // case SHAPE_TYPE.CIRCLE:
                //     if (!this.isCanvasBound(SHAPE_TYPE.CIRCLE)) {
                //         this.setCanvasBound(SHAPE_TYPE.CIRCLE);
                //         // this.drawCircle();
                //         LogFirebase("Markup", "select_circle", "");
                //     }
                //     break;
                case SHAPE_TYPE.TEXT:
                    console.log("Selected shape: =====>", selectedShape);
                    if (!this.isCanvasBound(SHAPE_TYPE.TEXT)) {
                        this.setCanvasBound(SHAPE_TYPE.TEXT);
                        this.addText();
                        LogFirebase("Markup", "select_text", "");
                    }
                    break;
                case SHAPE_TYPE.BLUR:
                    console.log("Selected shape: =====>", selectedShape);
                    if (!this.isCanvasBound(SHAPE_TYPE.BLUR)) {
                        this.setCanvasBound(SHAPE_TYPE.BLUR);
                        this.drawMaskEffectForLocalUser();
                        LogFirebase("Markup", "select_mask_rectangle", "");
                    }
                    break;
                case SHAPE_TYPE.ARROW:
                    console.log("Selected shape: =====>", selectedShape);
                    if (!this.isCanvasBound(SHAPE_TYPE.ARROW)) {
                        this.setCanvasBound(SHAPE_TYPE.ARROW);
                        this.drawArrowForLocalUser();
                        LogFirebase("Markup", "select_arrow", "");
                    }
                    break;
                default:
                    break;
            }

            // When any other shape than free draw is selected, unset pencil
            if (selectedShape !== SHAPE_TYPE.FREEDRAW) {
                this.freeway = false;
                this.annCanvas.isDrawingMode = false;
            }

            // Set the selectable current shape
            this.setSelectableCurrent(selectedShape);
        }
    };

    setSelectableCurrent = (currentShape) => {
        // Iterate over each object in the annotation canvas
        this.annCanvas?.forEachObject((obj) => {
            // Check if the object's shape type matches the current shape and if it's a local shape
            if (obj.shape_type == currentShape && obj.localshape !== undefined && obj.localshape === true) {
                // Make the object selectable and evented
                obj.set({
                    selectable: true,
                    evented: true,
                    hoverCursor: obj.shape_type === SHAPE_TYPE.FREEDRAW ? "default" : "grabbing",
                });
                console.log("Selectable:");
                console.log(obj);
            } else {
                // Make the object unselectable and non-evented
                obj.set({
                    selectable: false,
                    evented: false,
                    hoverCursor: "default",
                });
                console.log("Unselectable:");
                console.log(obj);
            }
        });
    };

    resetCanvasBound = () => {
        this.canvasBound = {
            1: false,
            2: false,
            3: false,
            4: false,
            6: false,
        };
    };

    isCanvasBound = (key) => {
        return this.canvasBound[key];
    };

    setCanvasBound = (key) => {
        console.log("Shape ==>", this.canvasBound);
        this.canvasBound[key] = true;
        console.log("Shape List ==>", this);
        console.log("Shape ==>", this.canvasBound);
    };

    freeDrawMouseDownHandler = (o) => {
        this.closeMarkupDropdown();
        this.xyPosVal = [];
        let dateTime = new Date();
        this.currTimeStamp = dateTime.getTime();
        if (this.shape != SHAPE_TYPE.FREEDRAW) {
            return;
        }
        if (this.allShapeDisable) {
            this.isDragging = false;
            return;
        } // if app is background during AR markup, disable all the shapes
        const shapeTypeText = this.getShapeText(SHAPE_TYPE.FREEDRAW);
        googleEvent.logEvent("MARKUP_" + shapeTypeText);
        console.log("free drawing mouse down");

        this.freedrwcnt = this.freedrwcnt + 1;
        this.isDragging = true;
        this.pointer = this.annCanvas.getPointer(o.e);
        this.startpointx = this.pointer.x;
        this.startpointy = this.pointer.y;
        this.xyPosVal.push({ x: this.pointer.x, y: this.pointer.y });
    };

    freeDrawMouseMoveHandler = (o) => {
        if (this.shape != SHAPE_TYPE.FREEDRAW) {
            return;
        }
        if (this.allShapeDisable) {
            this.isDragging = false;
            return;
        } // if app is background during AR markup, disable all the shapes
        if (this.isDragging == true) {
            this.pointer = this.annCanvas.getPointer(o.e);
            this.xyPosVal.push({ x: this.pointer.x, y: this.pointer.y });
        }
    };

    divideFreeDrawInChunks = (annmsgpoints) => {
        // mark up & live stream
        let currentChunk = [];
        let currentSize = 0;

        let isFirstChunk = false;
        annmsgpoints.forEach((point, index) => {
            if (index == 0) isFirstChunk = true;
            const pointSize = new TextEncoder().encode(JSON.stringify(point)).length;
            if (currentSize + pointSize > MAX_CHUNK_SIZE) {
                // If adding the point exceeds the limit, send the current chunk and start a new one
                this.sendChunk(currentChunk, false, isFirstChunk ? 0 : annmsgpoints.length);
                currentChunk = [];
                currentSize = 0;
                isFirstChunk = false;
            }

            // Add the point to the current chunk and update the size
            currentChunk.push(point);
            currentSize += pointSize;
        });

        // Send the last chunk
        if (currentChunk.length > 0) {
            this.sendChunk(currentChunk, true, annmsgpoints.length);
        }
        if (reduxStore.getState().markup.markupInprogress) {
            this.prepareLocalShapesList();
            //when new object is drawn, redo can not be done on earlier undone objects.so clear it.
            this.resetlocalUndoList();
            enableSaveMarkup();
        }
    };

    sendChunk = (chunk, isLastChunk, index) => {
        let pointStatus;
        if (index === 0) {
            pointStatus = "1";
        } else if (isLastChunk) {
            pointStatus = "3";
        } else {
            pointStatus = "2";
        }
        let notificationType;

        if (reduxStore.getState().markup.markupLiveStream) {
            notificationType = NOTIFICATION_TYPES.REMOTE_MARKUP_LIVESTREAM;
        } else if (arMarkupService.checkARMarkupIsOngoing()) {
            notificationType = NOTIFICATION_TYPES.REMOTE_AR_MARKUP_LIVESTREAM;
        } else {
            notificationType = NOTIFICATION_TYPES.REMOTE_MARKUP;
        }
        let markupmessage = {
            pointStatus: pointStatus,
            notification_type: notificationType,
            ANNOTATION_POINT: JSON.stringify(chunk),
            sessionid: GLOBAL_MEETING_DATA.sessionId,
            device_type: GLOBAL_MEETING_DATA.device_type,
            objectid: this.currTimeStamp,
            shape_type: SHAPE_TYPE.FREEDRAW,
            status: shapeStatus.DRAW,
            is_shadow: reduxStore.getState().markup.isShadowOrStroke,
            shape_thickness: reduxStore.getState().markup.selectedThicknessForShape,
        };
        const markupmessageSize = new TextEncoder().encode(JSON.stringify(markupmessage)).length;
        console.log("markupmessageSize", markupmessageSize); // currenlty just for testing purpose adding
        sendDataTrack(markupmessage);
    };

    freeDrawMouseUpHandler = (o) => {
        // if app is background during AR markup, disable all the shapes
        if (this.freeway) {
            this.isDragging = false;
            this.annCanvas.forEachObject(function (o) {
                o.selectable = false;
            });

            const annCanvasHeight = this.annCanvas.getHeight();
            const annCanvasWidth = this.annCanvas.getWidth();
            const annmsgpoints = this.xyPosVal.map((val, index) => {
                return {
                    XPOINTS: val.x,
                    YPOINTS: val.y,
                    XPOINTS_START: index === 0 ? this.startpointx : this.xyPosVal[index - 1].x,
                    YPOINTS_START: index === 0 ? this.startpointy : this.xyPosVal[index - 1].y,
                    HEIGHT: annCanvasHeight,
                    WIDTH: annCanvasWidth,
                    COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                };
            });
            this.changeCanvasObjLength("add");
            let message = {
                ANNOTATION_POINT: JSON.stringify(annmsgpoints),
                sessionid: GLOBAL_MEETING_DATA.sessionId,
                device_type: GLOBAL_MEETING_DATA.device_type,
                objectid: this.currTimeStamp,
                shape_type: SHAPE_TYPE.FREEDRAW,
                status: shapeStatus.DRAW,
            };

            if (reduxStore.getState().markup.markupLiveStream) {
                //need to add in localshape list as obj will be removed from canvas
                const freeObj = this.annCanvas.getObjects().filter((obj) => obj.localshape);
                console.log("free drawing objects");
                console.log(freeObj);
                this.addInLocalList(freeObj[0]);
            }

            if (arMarkupService.checkARMarkupIsOngoing()) {
                message.notification_type = NOTIFICATION_TYPES.REMOTE_AR_MARKUP_LIVESTREAM;
                //need to add in localshape list as obj will be removed from canvas
                const freeObj = this.annCanvas.getObjects().filter((obj) => obj.localshape);
                console.log("free drawing objects");
                console.log(freeObj);
                this.addInLocalList(freeObj[0]);
            }
            this.divideFreeDrawInChunks(annmsgpoints);

            LogFirebase("Markup", "send_msg_shape_type", message.shape_type + "::" + SHAPE_TYPE.FREEDRAW);
            LogFirebase("Markup", "current_objects_count", reduxStore.getState().markup.annPointlength);
        }

        if (reduxStore.getState().markup.markupLiveStream || arMarkupService.checkARMarkupIsOngoing()) {
            this.removeRecentDrawnObject();
        }
    };

    startFreeDrawing = () => {
        this.setFreeDrawingParam();
        this.annCanvas
            .on("mouse:down", (o) => {
                this.freeDrawMouseDownHandler(o);
            })

            .on("mouse:move", (o) => {
                this.freeDrawMouseMoveHandler(o);
            })

            .on("mouse:up", (o) => {
                if (this.shape != SHAPE_TYPE.FREEDRAW) {
                    return;
                }
                if (this.allShapeDisable) {
                    this.isDragging = false;
                    return;
                }

                this.freeDrawMouseUpHandler(o);

                if (reduxStore.getState().markup.markupLiveStream || arMarkupService.checkARMarkupIsOngoing()) {
                    this.removeRecentDrawnObject();
                }
            })
            .on("path:created", ({ path }) => {
                if (this.isDragging) {
                    //need to assign id and localshape prop for undo redo
                    path.id = this.currTimeStamp;
                    path.localshape = true;
                    path.shape_type = SHAPE_TYPE.FREEDRAW;
                    console.log(path.id + ":" + path.localshape);
                }
            });
    };

    setFreeDrawingParam = () => {
        this.iscirlce = false;
        this.isresetted = false;
        if (this.allShapeDisable) {
            // if app is background during AR markup, disable all the shapes
        } else {
            this.freeway = true;
            this.annCanvas.isDrawingMode = true;
            this.annCanvas.selection = false;
        }
        this.annCanvas.freeDrawingBrush.color = COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex];
        this.annCanvas.freeDrawingBrush.width = arMarkupService.checkARMarkupIsOngoing()
            ? parseInt(5, 10) || 1
            : reduxStore.getState().markup.selectedThicknessForShape || SHAPE_THICKNESS[5]; // 10px
        this.annCanvas.freeDrawingBrush.shadow = arMarkupService.checkARMarkupIsOngoing()
            ? false
            : showShadow(reduxStore.getState().markup.isShadowOrStroke);
        //// $scope.trackPoints = function (e) {
        ////     allPoints.push({ x: e.pageX, y: e.pageY });
        //// }

        //// $rootScope.freedrwcnt = 0;
    };

    drawRectangle = () => {
        let annmsgpoints = [];
        this.annCanvas
            .on("mouse:down", (o) => {
                this.closeMarkupDropdown();
                //for select and move
                if (this.annCanvas.findTarget(o.e)) {
                    if (this.annCanvas.findTarget(o.e).localshape == true) {
                        return;
                    } // return to select and move if current state
                }
                if (this.shape != SHAPE_TYPE.RECT) {
                    return;
                } //same canvas for different shape
                if (this.allShapeDisable) {
                    this.isDrawingRect = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                //required to set
                this.isresetted = false;

                //reset origin
                this.pointer = this.annCanvas.getPointer(o.e);
                this.origX = this.pointer.x;
                this.origY = this.pointer.y;
                this.isMovingRect = false;
                this.isDrawingRect = true;
                console.log("::Down");
                const rectangleFeatures = {
                    startX: this.origX,
                    startY: this.origY,
                    endX: this.pointer.x,
                    endY: this.pointer.y,
                    color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    shapeType: SHAPE_TYPE.RECT,
                    strokeWidth: arMarkupService.checkARMarkupIsOngoing()
                        ? SHAPE_THICKNESS[5] // 10px
                        : reduxStore.getState().markup.selectedThicknessForShape,
                    isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : reduxStore.getState().markup.isShadowOrStroke,
                    aRmarkupLiveStream: arMarkupService.checkARMarkupIsOngoing(),
                };
                this.rect = generateRectangle(rectangleFeatures);
                this.rect.set("localshape", true);
                this.annCanvas.add(this.rect).setActiveObject(this.rect);
            })
            .on("mouse:move", (o) => {
                if (this.shape != SHAPE_TYPE.RECT) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingRect = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                //for move
                if (!this.isDrawingRect) {
                    return;
                }

                if (this.isDrawingRect) {
                    this.rect = this.annCanvas.getActiveObject();

                    this.pointer = this.annCanvas.getPointer(o.e);
                    if (this.origX > this.pointer.x) {
                        this.rect.set({ left: Math.abs(this.pointer.x) });
                    }
                    if (this.origY > this.pointer.y) {
                        this.rect.set({ top: Math.abs(this.pointer.y) });
                    }
                    this.rect.set({ width: Math.abs(this.origX - this.pointer.x) });
                    this.rect.set({ height: Math.abs(this.origY - this.pointer.y) });
                    this.rect.setCoords();
                    this.annCanvas.renderAll();
                }
            })
            .on("mouse:up", (o) => {
                if (this.shape != SHAPE_TYPE.RECT) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingRect = false;
                    return;
                }
                //if mouse up after moving
                if (this.isMovingRect) {
                    console.log("move done");
                    //get moved object's new properties
                    let newRect = this.annCanvas.getActiveObject();
                    console.log(newRect);
                    this.changeLocalShapeList(newRect);
                    let annMsg = {
                        XPOINTS_START: newRect.left, //new x after move
                        YPOINTS_START: newRect.top, //new y after move
                        XPOINTS_END: newRect.left + newRect.width,
                        YPOINTS_END: newRect.top + newRect.height,
                        HEIGHT: this.annCanvas.getHeight(),
                        WIDTH: this.annCanvas.getWidth(),
                        COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    };
                    annmsgpoints[0] = annMsg;
                    //send message to users for MOVED Rectangle
                    this.sendAnnotationPointsMsg(newRect.id, annmsgpoints, SHAPE_TYPE.RECT, shapeStatus.MOVE);
                    this.isMovingRect = false;
                }
                //if mouse up after drawing
                if (this.isDrawingRect) {
                    let newRect = this.annCanvas.getActiveObject();
                    if (newRect.height > 0 && newRect.width > 0) {
                        let dateTime = new Date();
                        this.currTimeStamp = dateTime.getTime();
                        newRect.set("id", this.currTimeStamp);
                        this.pointer = this.annCanvas.getPointer(o.e);
                        let annMsg = {
                            XPOINTS_START: this.origX,
                            YPOINTS_START: this.origY,
                            XPOINTS_END: this.pointer.x,
                            YPOINTS_END: this.pointer.y,
                            HEIGHT: this.annCanvas.getHeight(),
                            WIDTH: this.annCanvas.getWidth(),
                            COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                        };
                        annmsgpoints[0] = annMsg;
                        this.addInLocalList(newRect);
                        //send message to users for NEWLY DRAWN Rectangle
                        this.sendAnnotationPointsMsg(newRect.id, annmsgpoints, SHAPE_TYPE.RECT, shapeStatus.DRAW);
                        this.isDrawingRect = false;
                    } else {
                        this.isDrawingRect = false;
                        this.annCanvas.remove(newRect);
                    }
                }
                this.origX = this.orignY = 0;
                this.pointer = null;
            })
            .on("object:moving", (o) => {
                if (this.shape != SHAPE_TYPE.RECT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                console.log("rect moving");
                this.isDrawingRect = false;
                this.isMovingRect = true;
            });
    };

    /** below fun will draw rectangle by given points in notification */
    drawRectangleByPoints = (data) => {
        let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
        let annpointRemote = annmsgpoint[0];
        let annpoint = this.convertByLocalCanvas(annpointRemote);
        let sx = annpoint.XPOINTS_START;
        let sy = annpoint.YPOINTS_START;
        let ex = annpoint.XPOINTS_END;
        let ey = annpoint.YPOINTS_END;

        if (annpoint.XPOINTS_START > annpoint.XPOINTS_END) {
            sx = annpoint.XPOINTS_END;
            ex = annpoint.XPOINTS_START;
        }
        if (annpoint.YPOINTS_START > annpoint.YPOINTS_END) {
            sy = annpoint.YPOINTS_END;
            ey = annpoint.YPOINTS_START;
        }

        const rectangleFeatures = {
            startX: sx,
            startY: sy,
            endX: ex,
            endY: ey,
            color: annpoint.COLOR,
            shapeType: SHAPE_TYPE.RECT,
            strokeWidth: arMarkupService.checkARMarkupIsOngoing() ? SHAPE_THICKNESS[5] : parseInt(data?.shape_thickness), // 10px
            isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : data?.is_shadow,
            aRmarkupLiveStream: arMarkupService.checkARMarkupIsOngoing(),
        };
        this.rect = generateRectangle(rectangleFeatures);
        this.rect.set("selectable", false);
        this.rect.set("id", data.objectid);
        this.rect.set("localshape", false);
        this.rect.set("hoverCursor", "default");
        this.annCanvas.add(this.rect);
    };

    drawMaskEffectForLocalUser = () => {
        let annmsgpoints = [];
        this.annCanvas
            .on("mouse:down", (o) => {
                this.closeMarkupDropdown();
                //for select and move
                if (this.annCanvas.findTarget(o.e)) {
                    if (this.annCanvas.findTarget(o.e).localshape == true) {
                        return;
                    } // return to select and move if current state
                }
                if (this.shape != SHAPE_TYPE.BLUR) {
                    return;
                } //same canvas for different shape
                if (this.allShapeDisable) {
                    this.isDrawingBlur = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                //required to set
                this.isresetted = false;

                //reset origin
                this.pointer = this.annCanvas.getPointer(o.e);
                this.origX = this.pointer.x;
                this.origY = this.pointer.y;
                this.isDrawingBlur = true;
                this.isMovingBlur = false;
                console.log("::Down");
                const blurFeatures = {
                    startX: this.origX,
                    startY: this.origY,
                    endX: this.pointer.x,
                    endY: this.pointer.y,
                    color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    shapeType: SHAPE_TYPE.BLUR,
                    strokeWidth: arMarkupService.checkARMarkupIsOngoing()
                        ? SHAPE_THICKNESS[5] // 10px
                        : reduxStore.getState().markup.selectedThicknessForShape,
                    isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : reduxStore.getState().markup.isShadowOrStroke,
                    aRmarkupLiveStream: arMarkupService.checkARMarkupIsOngoing(),
                };
                this.blur = generateRectangle(blurFeatures);
                this.blur.set("localshape", true);
                this.annCanvas.add(this.blur).setActiveObject(this.blur);
            })
            .on("mouse:move", (o) => {
                if (this.shape != SHAPE_TYPE.BLUR) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingBlur = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                if (!this.isDrawingBlur) {
                    return;
                }

                if (this.isDrawingBlur) {
                    this.blur = this.annCanvas.getActiveObject();
                    this.pointer = this.annCanvas.getPointer(o.e);
                    if (this.origX > this.pointer.x) {
                        this.blur.set({ left: Math.abs(this.pointer.x) });
                    }
                    if (this.origY > this.pointer.y) {
                        this.blur.set({ top: Math.abs(this.pointer.y) });
                    }
                    this.blur.set({ width: Math.abs(this.origX - this.pointer.x) });
                    this.blur.set({ height: Math.abs(this.origY - this.pointer.y) });
                    this.blur.setCoords();
                    this.annCanvas.renderAll();
                }
            })
            .on("mouse:up", (o) => {
                if (this.shape != SHAPE_TYPE.BLUR) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingBlur = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                //if mouse up after moving
                if (this.isMovingBlur) {
                    //get moved object's new properties
                    let newBlurRect = this.annCanvas.getActiveObject();
                    this.changeLocalShapeList(newBlurRect);
                    let annMsg = {
                        XPOINTS_START: newBlurRect.left, //new x after move
                        YPOINTS_START: newBlurRect.top, //new y after move
                        XPOINTS_END: newBlurRect.left + newBlurRect.width,
                        YPOINTS_END: newBlurRect.top + newBlurRect.height,
                        HEIGHT: this.annCanvas.getHeight(),
                        WIDTH: this.annCanvas.getWidth(),
                        COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    };
                    annmsgpoints[0] = annMsg;
                    //send message to users for MOVED Rectangle
                    this.sendAnnotationPointsMsg(newBlurRect.id, annmsgpoints, SHAPE_TYPE.BLUR, shapeStatus.MOVE);
                    this.isMovingBlur = false;
                }
                //if mouse up after drawing
                if (this.isDrawingBlur) {
                    let newBlur = this.annCanvas.getActiveObject();
                    if (newBlur.height > 0 && newBlur.width > 0) {
                        let dateTime = new Date();
                        this.currTimeStamp = dateTime.getTime();
                        newBlur.set("id", this.currTimeStamp);
                        this.pointer = this.annCanvas.getPointer(o.e);
                        let annMsg = {
                            XPOINTS_START: this.origX,
                            YPOINTS_START: this.origY,
                            XPOINTS_END: this.pointer.x,
                            YPOINTS_END: this.pointer.y,
                            HEIGHT: this.annCanvas.getHeight(),
                            WIDTH: this.annCanvas.getWidth(),
                            COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                        };
                        annmsgpoints[0] = annMsg;
                        // send message to users for NEWLY DRAWN Rectangle

                        // Create a temporary canvas to draw the cropped rectangle
                        this.addInLocalList(newBlur);
                        //send message to users for NEWLY DRAWN Rectangle
                        this.sendAnnotationPointsMsg(newBlur.id, annmsgpoints, SHAPE_TYPE.BLUR, shapeStatus.DRAW);
                        this.isDrawingBlur = false;
                    } else {
                        this.isDrawingBlur = false;
                        this.annCanvas.remove(newBlur);
                    }
                }
            })
            .on("object:moving", (o) => {
                if (this.shape != SHAPE_TYPE.BLUR) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                this.isDrawingBlur = false;
                this.isMovingBlur = true;
            });
    };

    /** below fun will draw rectangle by given points in notification */
    drawBlurByPoints = (data) => {
        let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
        let annpointRemote = annmsgpoint[0];
        let annpoint = this.convertByLocalCanvas(annpointRemote);
        let sx = annpoint.XPOINTS_START;
        let sy = annpoint.YPOINTS_START;
        let ex = annpoint.XPOINTS_END;
        let ey = annpoint.YPOINTS_END;

        if (annpoint.XPOINTS_START > annpoint.XPOINTS_END) {
            sx = annpoint.XPOINTS_END;
            ex = annpoint.XPOINTS_START;
        }
        if (annpoint.YPOINTS_START > annpoint.YPOINTS_END) {
            sy = annpoint.YPOINTS_END;
            ey = annpoint.YPOINTS_START;
        }

        const rectangleFeatures = {
            startX: sx,
            startY: sy,
            endX: ex,
            endY: ey,
            color: annpoint.COLOR,
            shapeType: SHAPE_TYPE.BLUR,
            strokeWidth: arMarkupService.checkARMarkupIsOngoing() ? SHAPE_THICKNESS[5] : parseInt(data?.shape_thickness), // 10px
            isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : data?.is_shadow,
            aRmarkupLiveStream: arMarkupService.checkARMarkupIsOngoing(),
        };
        this.rect = generateRectangle(rectangleFeatures);
        this.rect.set("selectable", false);
        this.rect.set("id", data.objectid);
        this.rect.set("localshape", false);
        this.rect.set("hoverCursor", "default");
        this.annCanvas.add(this.rect);
    };

    drawArrowForLocalUser = () => {
        let annmsgpoints = [];

        this.annCanvas
            .on("mouse:down", (o) => {
                this.closeMarkupDropdown();
                //for select and move
                if (this.annCanvas.findTarget(o.e)) {
                    if (this.annCanvas.findTarget(o.e).localshape == true) {
                        return;
                    } // return to select and move if current state
                }
                if (this.shape != SHAPE_TYPE.ARROW) {
                    return;
                } //same canvas for different shape
                if (this.allShapeDisable) {
                    this.isDrawingArrow = false;
                    return;
                }
                // if app is background during AR markup, disable all the shapes
                if (arMarkupService.checkARMarkupIsOngoing() && this.numberOfCountForARMarkupArrow >= 25) {
                    // if AR markup ON and count is greater than eual to 25 number then disable arrow shapes
                    CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["max_ar_arrow_limit_toast_message"]);
                    return;
                }

                this.isresetted = false; //required to set

                console.log("Arrow down");
                this.pointer = this.annCanvas.getPointer(o.e);
                this.isMovingArrow = false;
                this.isDrawingArrow = true;
                this.origX = this.pointer.x;
                this.origY = this.pointer.y;
                let mouseDownGenerateArrowFeatures = {
                    fromx: this.origX,
                    fromy: this.origY,
                    tox: this.pointer.x,
                    toy: this.pointer.y,
                    color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    strokeWidth: arMarkupService.checkARMarkupIsOngoing()
                        ? SHAPE_THICKNESS[5] // 10px
                        : reduxStore.getState().markup.selectedThicknessForShape,
                    isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : reduxStore.getState().markup.isShadowOrStroke,
                };
                this.arrowObj = generateArrow(mouseDownGenerateArrowFeatures);
                console.log("arrowObj down", this.arrowObj);
                if (!arMarkupService.checkARMarkupIsOngoing()) {
                    // do not render arrow point if AR Markup is true or ON
                    this.annCanvas.add(this.arrowObj).setActiveObject(this.arrowObj);
                }
            })
            .on("mouse:move", (o) => {
                if (this.shape != SHAPE_TYPE.ARROW) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingArrow = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                if (!this.isDrawingArrow) {
                    return;
                } //for move
                if (this.isDrawingArrow) {
                    console.log("Arrow Move");
                    this.pointer = this.annCanvas.getPointer(o.e);
                    this.annCanvas.remove(this.arrowObj);
                    let mouseMoveGenerateArrowFeatures = {
                        fromx: this.origX,
                        fromy: this.origY,
                        tox: this.pointer.x,
                        toy: this.pointer.y,
                        color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                        strokeWidth: arMarkupService.checkARMarkupIsOngoing()
                            ? SHAPE_THICKNESS[5] // 10px
                            : reduxStore.getState().markup.selectedThicknessForShape,
                        isShadow: arMarkupService.checkARMarkupIsOngoing() ? false : reduxStore.getState().markup.isShadowOrStroke,
                    };
                    this.arrowObj = generateArrow(mouseMoveGenerateArrowFeatures);

                    if (!arMarkupService.checkARMarkupIsOngoing()) {
                        // do not render arrow if AR Markup is true or ON
                        console.log("arrowObj down", this.arrowObj);
                        this.annCanvas.add(this.arrowObj).setActiveObject(this.arrowObj);
                        this.annCanvas.renderAll();
                    }
                }
            })
            .on("mouse:up", (o) => {
                if (this.shape != SHAPE_TYPE.ARROW) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    this.isDrawingArrow = false;
                    return;
                } // if app is background during AR markup, disable all the shapes
                //if mouse up after moving
                if (this.isMovingArrow) {
                    console.log("move up");
                    //get moved object's new properties

                    let arrowsShape = this.annCanvas.getActiveObject();
                    this.pointer = this.annCanvas.getPointer(o.e);
                    let annMsg = {
                        XPOINTS_START: arrowsShape.left, //new x after move
                        YPOINTS_START: arrowsShape.top, //new y after move
                        XPOINTS_END: arrowsShape.left + arrowsShape.width,
                        YPOINTS_END: arrowsShape.top + arrowsShape.height,
                        HEIGHT: this.annCanvas.getHeight(),
                        WIDTH: this.annCanvas.getWidth(),
                        COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    };
                    annmsgpoints[0] = annMsg;
                    //send message to users for MOVED Rectangle
                    this.sendAnnotationPointsMsg(
                        arrowsShape.id,
                        annmsgpoints,
                        SHAPE_TYPE.ARROW,
                        shapeStatus.MOVE,
                        null,
                        true,
                        reduxStore.getState().markup.selectedThicknessForShape
                    );
                    this.isMovingArrow = false;
                    this.changeLocalShapeList(arrowsShape);
                }

                //if mouse up after drawing
                if (this.isDrawingArrow) {
                    console.log("Arrow mouse up");
                    const minimumSize = minimumArrowSize(reduxStore.getState().markup.selectedThicknessForShape);
                    if (
                        arMarkupService.checkARMarkupIsOngoing() ||
                        Math.abs(this.origX - this.pointer.x) >= minimumSize ||
                        Math.abs(this.origY - this.pointer.y) >= minimumSize
                    ) {
                        const dateTime = new Date();
                        this.currTimeStamp = dateTime.getTime();
                        const group = this.arrowObj;
                        group.set("id", this.currTimeStamp);
                        group.set("localshape", true);
                        group.set("selectable", true);
                        let annMsg = null;
                        if (!arMarkupService.checkARMarkupIsOngoing()) {
                            this.annCanvas.remove(this.arrowObj); // removing old object
                            this.annCanvas.add(group).setActiveObject(group); // add grouping object
                            annMsg = {
                                XPOINTS_START: this.origX, //new x after move
                                YPOINTS_START: this.origY, //new y after move
                                XPOINTS_END: this.pointer.x,
                                YPOINTS_END: this.pointer.y,
                                HEIGHT: this.annCanvas.getHeight(),
                                WIDTH: this.annCanvas.getWidth(),
                                COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                            };
                        }

                        if (arMarkupService.checkARMarkupIsOngoing() && this.numberOfCountForARMarkupArrow <= 25) {
                            this.increaseDecreaseArrowCount(INCREASE);
                            annMsg = {
                                XPOINTS_START: this.origX, //new x after move
                                YPOINTS_START: this.origY, //new y after move
                                XPOINTS_END: this.pointer.x,
                                YPOINTS_END: this.pointer.y,
                                HEIGHT: this.annCanvas.getHeight(),
                                WIDTH: this.annCanvas.getWidth(),
                                COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                                ArrowCount: this.numberOfCountForARMarkupArrow, // in this variable we store the arrow count to send in the data track
                            };
                        }
                        annmsgpoints[0] = annMsg;
                        this.addInLocalList(group);
                        //send message to users for NEWLY DRAWN Arrow
                        this.sendAnnotationPointsMsg(
                            group.id,
                            annmsgpoints,
                            SHAPE_TYPE.ARROW,
                            shapeStatus.DRAW,
                            null,
                            true,
                            reduxStore.getState().markup.selectedThicknessForShape
                        );
                        this.isDrawingArrow = false;
                    } else {
                        this.annCanvas.remove(this.arrowObj); // removing old object
                        this.isDrawingArrow = false;
                    }
                }
            })
            .on("object:moving", (e) => {
                console.log("arrow moving");
                if (this.shape != SHAPE_TYPE.ARROW) {
                    return;
                } //same canvas for different shapes
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                this.isDrawingArrow = false;
                this.isMovingArrow = true;
            });

        if (arMarkupService.checkARMarkupIsOngoing()) {
            // do not render arrow if AR Markup is true or ON
            this.annCanvas.renderAll();
        }
    };

    drawArrowBasedOnRemoteUserPoint = (data) => {
        console.log("draw arrow by points-----------");
        let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
        let annpointRemote = annmsgpoint[0];
        let annpoint = this.convertByLocalCanvas(annpointRemote);
        console.log("annpointannpoint", annpoint);
        let drawArrowFeatures = {
            fromx: annpoint.XPOINTS_START,
            fromy: annpoint.YPOINTS_START,
            tox: annpoint.XPOINTS_END,
            toy: annpoint.YPOINTS_END,
            color: annpoint.COLOR,
            strokeWidth: parseInt(data?.shape_thickness),
            isShadow: data?.is_shadow,
        };
        let arrowObj = generateArrow(drawArrowFeatures);
        arrowObj.set("localshape", false);
        arrowObj.set("selectable", false);
        arrowObj.set("hoverCursor", "default");
        arrowObj.set("id", data.objectid);
        this.annCanvas.add(arrowObj);
        this.annCanvas.renderAll();
    };

    addText = () => {
        this.MarkupDefaultText = Localize[PublicVariables.currentLanguageObj.languageCode]["enter_text_here"];
        this.annCanvas
            .on("mouse:up", (o) => {
                if (this.shape != SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                console.log("text mouse up");
                let txt = this.annCanvas.getActiveObject();
                if (txt != null && txt.shape_type != SHAPE_TYPE.TEXT) {
                    return;
                }
                //send message on move obj & turn of mouse move on up.
                if (this.isMovingText) {
                    console.log(txt);
                    this.preparTextAnnotation(txt, shapeStatus.MOVE);
                    this.isMovingText = false;
                    this.changeLocalShapeList(txt);
                }
            })
            .on("mouse:down", (o) => {
                this.closeMarkupDropdown();
                //as canvas is common for all the shapes so perform only when shape type is text
                if (this.shape != SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                this.newLineAdded = false;
                this.isMovingText = false;
                console.log("text mouse down");
                if (o.target == null || (o.target && o.target.localshape == false)) {
                    //required to set
                    this.isresetted = false;
                    this.escape = false;

                    this.txtboxMsgSent = false;
                    this.pointer = this.annCanvas.getPointer(o.e);
                    const textBoxFeatures = {
                        startX: this.pointer.x,
                        startY: this.pointer.y,
                        color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                        isShadowAndStroke: arMarkupService.checkARMarkupIsOngoing() ? false : reduxStore.getState().markup.isShadowOrStroke,
                        fontSize: reduxStore.getState().markup.selectedFontSizeForShape,
                        defaultText: this.MarkupDefaultText,
                        shapeType: SHAPE_TYPE.TEXT,
                    };
                    this.textbox = generateTextbox(textBoxFeatures);
                    let dateTime = new Date();
                    this.currTimeStamp = dateTime.getTime();
                    this.textbox.set("id", this.currTimeStamp);
                    this.textbox.set("localshape", true);
                    console.log(this.textbox);
                    this.annCanvas.add(this.textbox).setActiveObject(this.textbox);
                    this.textbox.enterEditing();
                    if (navigatorService.isLatestAndroidChrome()) {
                        //add for latest android chrome only
                        this.textbox.hiddenTextarea.blur();
                        this.textbox.hiddenTextarea.focus();
                    }
                    this.textbox.selectAll();
                }
            })
            .on("object:moving", (o) => {
                if (this.shape != SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                const txt = o.target;
                if (txt != null && txt.shape_type != SHAPE_TYPE.TEXT) {
                    return;
                }
                console.log(o);
                console.log("TEXT moving");
                this.txtboxMsgSent = false;
                this.isMovingText = true;
            })
            .on("text:editing:entered", (o) => {
                if (this.shape != SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                console.log("text edit entered");
                console.log(o);
            })
            .on("text:editing:exited", (o) => {
                if (this.shape != SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.allShapeDisable) {
                    return;
                } // if app is background during AR markup, disable all the shapes
                console.log("text edit exited");
                let txt = this.annCanvas.getActiveObject();

                //once placed, textbox should not be editable
                txt.set({ editable: false });
                console.log(txt);
                this.addInLocalList(txt);
                this.preparTextAnnotation(txt, shapeStatus.DRAW);
            });
        fabric.Object.prototype.objectCaching = false;

        /** To bind the enter key with every textbox  */
        fabric.IText.prototype.onKeyDown = (() => {
            const _this = this;
            return function (e) {
                if (_this.shape !== SHAPE_TYPE.TEXT) {
                    return;
                }
                if (_this.allShapeDisable) {
                    return;
                }
                if (this.text.length > MaximumCharInOneLine) {
                    let newLine = "\n";
                    let txt = this.text;
                    let posNewLine = txt.search(newLine);
                    if (posNewLine < 0 && txt != _this.MarkupDefaultText) {
                        let formattedText = _this.formatNewLineText(this);
                        _this.changeText(formattedText, this);
                    } else {
                        console.log("NO new line");
                    }
                }
                if (GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.DESKTOP) {
                    //desktop keydown behaves different so block keys
                    if (this.text.length > MaximumCharForText - 1) {
                        if (
                            e.keyCode == KEYBOARD_KEYS.BACKSPACE ||
                            e.keyCode == KEYBOARD_KEYS.DELETE ||
                            e.keyCode == KEYBOARD_KEYS.ENTER ||
                            e.keyCode == KEYBOARD_KEYS.RIGHT_ARROW ||
                            e.keyCode == KEYBOARD_KEYS.LEFT_ARROW
                        ) {
                            console.log("allow action");
                            //allow keydown of backspace,delete,enter and left-right arrow
                        } else {
                            e.preventDefault();
                            return false;
                        }
                    }
                }

                if (e.keyCode == KEYBOARD_KEYS.ENTER) {
                    console.log("enter key pressed");
                    e.preventDefault();
                    this.exitEditing();
                    return false;
                }
            };
        })(fabric.IText.prototype.onKeyDown);

        fabric.IText.prototype.onKeyUp = (() => {
            const _this = this;
            return function (e) {
                if (GLOBAL_MEETING_DATA.device_type != DEVICE_TYPES.DESKTOP) {
                    //mweb behaves differently than web so handle on keyup
                    if (this.text.length > MaximumCharForText) {
                        const newText = this.text.substr(0, MaximumCharForText);
                        _this.changeText(newText, this);
                    }
                }
                if (_this.shape !== SHAPE_TYPE.TEXT) {
                    return;
                }
                console.log("onKeyUp");
                //FIX : backspace and enter in android chrome appends "\nEnter"
                console.log("code=" + e.keyCode + "::text=" + this.text);
                let fromLast = "";
                let backspace = false;
                let enterkey = false;
                if (this.text.indexOf("\nEnter", fromLast) > -1) {
                    enterkey = true;
                    fromLast = this.text.length - "\nEnter".length + 1;
                }
                if (this.text.indexOf(" Enter", fromLast) > -1) {
                    backspace = true;
                    fromLast = this.text.length - " Enter".length + 1;
                }
                console.log("::backspace=" + backspace + "::enterkey=" + enterkey);
                if (backspace || enterkey) {
                    let tempText = this.text.substr(0, fromLast - 1);
                    console.log("after removing enter");
                    if (enterkey) {
                        this.textLines.pop();
                    }
                    this.text = tempText;
                    console.log(this);
                }
            };
        })(fabric.IText.prototype.onKeyUp);
    };

    getFontSizeForArMarkup = () => {
        let fontSizeVar = MarkupTextSize.toString();
        const userDetails = getUserDetailsById(reduxStore.getState().twilioEvents.streamingPartiIdentity);
        if (this.annCanvas.height > 900 || this.annCanvas.width > 900) {
            const { isLocalUserScreenSharing, isOpponentUserScreenSharing } = reduxStore.getState().twilioEvents.isLocalUserScreenSharing;
            if (userDetails?.device_type == DEVICE_TYPES.DESKTOP && (isLocalUserScreenSharing || isOpponentUserScreenSharing)) {
                fontSizeVar = MarkupTextSize.toString();
            } else {
                fontSizeVar = MarkupLargeTextSize.toString();
            }
        }
        return fontSizeVar;
    };

    addTextboxByPoints = (data) => {
        let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
        let annpointRemote = annmsgpoint[0];
        let annpoint = this.convertByLocalCanvas(annpointRemote);
        console.log(annpoint);
        console.log(annpoint.XPOINTS_START, annpoint.YPOINTS_START, annpoint.COLOR, data.is_shadow, data.font_size);
        const textBoxFeatures = {
            startX: annpoint.XPOINTS_START,
            startY: annpoint.YPOINTS_START,
            color: annpoint.COLOR,
            isShadowAndStroke: data.is_shadow,
            fontSize: data.font_size,
            defaultText: Localize[PublicVariables.currentLanguageObj.languageCode]["enter_text_here"],
            shapeType: SHAPE_TYPE.TEXT,
        };
        let textbox = generateTextbox(textBoxFeatures);
        let txt = data.text_str;
        LogFirebase("Markup", "textbox_text", txt);
        if (data.text_str.length > 36) {
            txt = data.text_str.substr(0, 36);
        }
        textbox.set("text", txt);
        textbox.set("id", data.objectid);
        textbox.set("selectable", false);
        textbox.set("localshape", false);
        textbox.set("hoverCursor", "default");
        //text conversion
        let fontSize = data.font_size;
        fontSize = Math.ceil(fontSize);
        console.log("fontsize after=" + fontSize);
        textbox.set("fontSize", fontSize);
        this.annCanvas.add(textbox);
    };

    moveTextboxByPoints = (data) => {
        //find perticular object which is moved
        this.annCanvas.forEachObject((obj) => {
            console.log(obj);
            if (obj.id == data.objectid) {
                let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
                let annpointRemote = annmsgpoint[0];
                let annpoint = this.convertByLocalCanvas(annpointRemote);
                obj.set("left", annpoint.XPOINTS_START);
                obj.set("top", annpoint.YPOINTS_START);
                this.annCanvas.renderAll();
                LogFirebase("Markup", "textbox_moved", "left=" + obj.left + "::top=" + obj.top);
            }
        });
    };

    resetlocalUndoList = () => {
        this.localUndoList = [];
        reduxStore.dispatch(setRedoEnabled(false));
    };

    /**change localShapeList on move object */
    changeLocalShapeList = (movedObj) => {
        if (this.localObjExistOnCanvas()) {
            this.prepareLocalShapesList();
        }
        let updated = false;
        this.localShapesList?.forEach((localObj, key) => {
            if (localObj.id == movedObj.id && !updated) {
                this.localShapesList.splice(key, 1); //remove from old index
                this.localShapesList.push(movedObj); //make it latest
                console.log("new shapes list");
                console.log(this.localShapesList);
                updated = true;
            }
        });
    };

    localObjExistOnCanvas = () => {
        if (this.localShapesList && this.localShapesList.length == 0) {
            return false;
        } else {
            return true;
        }
    };

    prepareLocalShapesList = () => {
        let allLocals;
        if (!reduxStore.getState().markup.markupLiveStream || !arMarkupService.checkARMarkupIsOngoing()) {
            allLocals = this.annCanvas.getObjects().filter((obj) => obj.localshape && obj.localshape == true);
            console.log("ALL objects");
            console.log(allLocals);
            this.localShapesList = allLocals;
        }
        if (this.localShapesList.length > 0) {
            enableMarkupUndo();
        }
    };

    /** sends 337 annotation message */
    sendAnnotationPointsMsg = (objid, points, shapeType, shapeStatusParams, textDetails) => {
        let message = {
            ANNOTATION_POINT: JSON.stringify(points),
            sessionid: GLOBAL_MEETING_DATA.sessionId.toString(),
            device_type: GLOBAL_MEETING_DATA.device_type.toString(),
            objectid: objid.toString(),
            shape_type: shapeType,
            status: shapeStatusParams,
        };
        if (reduxStore.getState().markup.markupLiveStream) {
            message.notification_type = NOTIFICATION_TYPES.REMOTE_MARKUP_LIVESTREAM;
        } else if (arMarkupService.checkARMarkupIsOngoing()) {
            message.notification_type = NOTIFICATION_TYPES.REMOTE_AR_MARKUP_LIVESTREAM;
        } else {
            message.notification_type = NOTIFICATION_TYPES.REMOTE_MARKUP;
        }
        if (!arMarkupService.checkARMarkupIsOngoing()) {
            // set thickness and shadow if the ARMarkupLiveStream is false
            message.is_shadow = reduxStore.getState().markup.isShadowOrStroke; // set the shadow and stoke value
            if (shapeType != SHAPE_TYPE.TEXT) {
                message.shape_thickness = reduxStore.getState().markup.selectedThicknessForShape; // set the thicknness value
            }
        }
        //set text details if shape type is text
        if (shapeType == SHAPE_TYPE.TEXT && textDetails) {
            message.text_str = textDetails.text_str;
            message.font_size = textDetails.font_size;
        }
        if (shapeStatusParams == shapeStatus.DRAW || shapeStatusParams == shapeStatus.REDO) {
            this.changeCanvasObjLength("add");
        }
        if (shapeStatusParams == shapeStatus.UNDO) {
            this.changeCanvasObjLength("remove");
        }
        if (this.localObjExistOnCanvas()) {
            this.callEnableSaveMarkup();
        } else {
            if (!this.objExistOnCanvas()) {
                reduxStore.dispatch(setSavebtndisabled(true));
            }
        }
        console.log("sending data track:" + message.notification_type);
        console.log(message);
        sendDataTrack(message);
        let shapeTypeText = this.getShapeText(message.shape_type);
        LogFirebase("Markup", "send_msg_shape_type", shapeTypeText + "::" + message.status);
        LogFirebase("Markup", "current_objects_count", this.canvasObjLength);
        if (shapeStatusParams == shapeStatus.DRAW) {
            googleEvent.logEvent("MARKUP_" + shapeTypeText);
            if (reduxStore.getState().markup.markupLiveStream || arMarkupService.checkARMarkupIsOngoing()) {
                setTimeout(() => {
                    this.removeRecentDrawnObject();
                }, 100);
            }
        }
    };
    changeCanvasObjLength = (action) => {
        if (action == "add") {
            this.canvasObjLength++;
        } else if (action == "remove") {
            this.canvasObjLength--;
        } else if (action == "reset") {
            this.canvasObjLength = 0;
        }
        reduxStore.dispatch(setAnnPointlength(this.canvasObjLength));
        if (this.canvasObjLength && this.canvasObjLength > 0) {
            reduxStore.dispatch(setSavebtndisabled(false));
        } else {
            reduxStore.dispatch(setSavebtndisabled(true));
        }
    };

    callEnableSaveMarkup = () => {
        enableSaveMarkup();
    };

    //local or remote any object is available
    objExistOnCanvas = () => {
        let retVal = false;
        if (!this.canvasObjLength) {
            retVal = false;
        } else {
            retVal = true;
        }
        return retVal;
    };

    getShapeText = (type) => {
        let typeText = "";
        if (type && this.shapeTextObj[type]) {
            typeText = this.shapeTextObj[type];
        }
        return typeText;
    };

    /**in live stream markup obj will be removed once drawn and data track sent */
    removeRecentDrawnObject = () => {
        if (reduxStore.getState().markup.markupLiveStream || arMarkupService.checkARMarkupIsOngoing()) {
            let latestobj = this.localShapesList[this.localShapesList.length - 1];
            this.annCanvas.remove(latestobj);
            this.annCanvas.discardActiveObject().renderAll();
        }
    };

    addInLocalList = (obj) => {
        //NO need add in local list for empty string or text placeholder
        if (obj && obj.shape_type == SHAPE_TYPE.TEXT && (this.isresetted || this.escape || this.isTextBoxEmpty(obj))) {
            return false;
        }
        this.localShapesList.push(obj);
        console.log("Local shapes list");
        console.log(this.localShapesList);
        enableMarkupUndo();
        //when new object is drawn, redo can not be done on earlier undone objects.so clear it.
        this.resetlocalUndoList();
    };

    checkTextPlaceholder = () => {
        const txt = this.annCanvas.getActiveObject();
        if (txt != null && txt.shape_type == SHAPE_TYPE.TEXT) {
            const retFlag = this.isTextBoxEmpty(txt);
            if (!retFlag) {
                txt.exitEditing();
            }
        }
    };

    isTextBoxEmpty = (txtObj) => {
        if (txtObj.text != null && (txtObj.text.trim() == "" || txtObj.text.trim() == this.MarkupDefaultText)) {
            console.log("removing textobj=" + txtObj.id);
            this.annCanvas.remove(txtObj);
            this.annCanvas.renderAll();
            return true;
        } else {
            return false;
        }
    };

    convertByLocalCanvas = (annpointRemote) => {
        let localPoints = [];
        localPoints = annpointRemote;
        let localCanwidth = this.annCanvas.width;
        let localCanheight = this.annCanvas.height;

        //multiply by local canvas dimension and divide by remote canvas dimension
        localPoints["XPOINTS_START"] = (annpointRemote.XPOINTS_START * localCanwidth) / annpointRemote.WIDTH;
        localPoints["YPOINTS_START"] = (annpointRemote.YPOINTS_START * localCanheight) / annpointRemote.HEIGHT;
        localPoints["XPOINTS_END"] = (annpointRemote.XPOINTS_END * localCanwidth) / annpointRemote.WIDTH;
        localPoints["YPOINTS_END"] = (annpointRemote.YPOINTS_END * localCanheight) / annpointRemote.HEIGHT;

        if (annpointRemote.TextContainerWidth != null) {
            localPoints["TextContainerWidth"] = (annpointRemote.TextContainerWidth * localCanwidth) / annpointRemote.WIDTH;
        }
        if (annpointRemote.TextContainerHeight != null) {
            localPoints["TextContainerHeight"] = (annpointRemote.TextContainerHeight * localCanheight) / annpointRemote.HEIGHT;
        }
        console.log("localPoints");
        console.log(localPoints);
        return localPoints;
    };

    selectShapeAction = (data) => {
        console.log("::shape received=" + data.shape_type);
        console.log("::action received=" + data.status);
        if (data.status == shapeStatus.UNDO) {
            this.undoRemoteObject(data);
            this.changeCanvasObjLength("remove");
        } else if (data.status == shapeStatus.REDO) {
            this.redoRemoteObject(data);
            this.changeCanvasObjLength("add");
        } else if (!reduxStore.getState().markup.markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
            //add on local canvas only for markup on image
            if (data.shape_type == SHAPE_TYPE.RECT) {
                if (data.status == shapeStatus.DRAW) {
                    this.drawRectangleByPoints(data);
                } else if (data.status == shapeStatus.MOVE) {
                    this.moveShapeBasedOnRemoteUserPoint(data, "rectangle");
                }
            } else if (data.shape_type == SHAPE_TYPE.TEXT) {
                if (data.status == shapeStatus.DRAW) {
                    this.addTextboxByPoints(data);
                } else if (data.status == shapeStatus.MOVE) {
                    this.moveTextboxByPoints(data);
                }
            } else if (data.shape_type == SHAPE_TYPE.BLUR) {
                if (data.status == shapeStatus.DRAW) {
                    this.drawBlurByPoints(data);
                } else if (data.status == shapeStatus.MOVE) {
                    this.moveShapeBasedOnRemoteUserPoint(data, "blur_rectangle");
                }
            } else if (data.shape_type == SHAPE_TYPE.ARROW) {
                if (data.status == shapeStatus.DRAW) {
                    this.drawArrowBasedOnRemoteUserPoint(data);
                } else if (data.status == shapeStatus.MOVE) {
                    this.moveShapeBasedOnRemoteUserPoint(data, "Arrow");
                }
            } else if (data.shape_type == SHAPE_TYPE.CIRCLE) {
                if (data.status == shapeStatus.DRAW) {
                    //// _this.drawCircleBasedOnRemoteUserPoint(data);
                } else if (data.status == shapeStatus.MOVE) {
                    this.moveShapeBasedOnRemoteUserPoint(data);
                }
            }
        }

        if (data.status == shapeStatus.DRAW) {
            this.changeCanvasObjLength("add");
        }
        LogFirebase("Markup", "current_objects_count", this.canvasObjLength);
    };

    getObjectById = (id) => {
        let selectedObj = null;
        this.annCanvas.forEachObject((obj) => {
            console.log(obj);

            //make local shapes selectable when user is in that shape mode
            if (obj.id == id && !selectedObj) {
                selectedObj = obj;
            }
        });
        return selectedObj;
    };

    moveShapeBasedOnRemoteUserPoint = (data, type) => {
        console.log("showing obj list");
        console.log(data);
        //find perticular object which is moved
        this.annCanvas.forEachObject((obj) => {
            if (obj.id == data.objectid) {
                let annmsgpoint = JSON.parse(data.ANNOTATION_POINT);
                let annpointRemote = annmsgpoint[0];
                let xpoint = annpointRemote.XPOINTS_START - annpointRemote.XPOINTS_END;
                let ypoint = annpointRemote.YPOINTS_START - annpointRemote.YPOINTS_END;
                annpointRemote.XPOINTS_END = xpoint;
                annpointRemote.YPOINTS_END = ypoint;
                const annpoint = this.convertByLocalCanvas(annpointRemote);
                obj.set("left", annpoint.XPOINTS_START);
                obj.set("top", annpoint.YPOINTS_START);
                obj.set("translateX", annpoint.XPOINTS_END);
                obj.set("translateY", annpoint.YPOINTS_END);
                this.annCanvas.renderAll();
                LogFirebase("Markup", type + "_moved", "left=" + obj.left + "::top=" + obj.top);
            }
        });
    };

    addPencilPathFromPoints = (liveclor, msg) => {
        let path = null;
        //// $rootScope.annCanvas.add(line);
        let pencil = new fabric.PencilBrush(this.annCanvas);

        // Convert Points to SVG Path
        let res = pencil.convertPointsToSVGPath(this.freeDrawPoints);
        // Create the Path
        path = pencil.createPath(res.toString());
        // Set the tickness and color
        path.set({
            strokeWidth: arMarkupService.checkARMarkupIsOngoing() ? parseInt(5, 10) || 1 : parseInt(msg.shape_thickness),
            stroke: liveclor,
            selectable: false,
            id: msg.objectid,
            hoverCursor: "default",
        });
        if (msg.is_shadow && !arMarkupService.checkARMarkupIsOngoing()) {
            path.set({
                shadow: "rgba(0, 0, 0, 1) 0px 2px 2px",
            });
        }
        // Add to the Canvas
        this.annCanvas.add(path);
        this.annCanvas.renderAll();
        this.freeDrawPoints = [];
        this.changeCanvasObjLength("add");
        enableSaveMarkup();
        LogFirebase("Markup", "current_objects_count", this.canvasObjLength);
    };

    managePencilPoints = (msg) => {
        let liveclor;
        let stpointx;
        let stpointy;
        //// let canvas = document.getElementsByClassName("upper-canvas")[0];
        let canvas = this.annCanvas;
        let annpoint = JSON.parse(msg.ANNOTATION_POINT);
        if (msg.pointStatus === "1") {
            this.freeDrawPoints = [];
        }

        annpoint.forEach((value1, key1) => {
            let mainwidth = canvas.width;
            let mainheight = canvas.height;
            let x = value1.XPOINTS_START;
            let y = value1.YPOINTS_START;
            // if the remote side is desktop
            if (msg.device_type == "3") {
                x = value1.XPOINTS_START - parseInt(msg.shape_thickness) / 2;
                y = value1.YPOINTS_START - parseInt(msg.shape_thickness) / 2;
            }
            stpointx = (x * mainwidth) / value1.WIDTH;
            stpointy = (y * mainheight) / value1.HEIGHT;
            //// let points = [stpointx, stpointy, pointx, pointy];
            liveclor = value1.COLOR;
            //need to convert in to point type as required in latest fabricjs 3.x
            this.freeDrawPoints.push(new fabric.Point(stpointx, stpointy));
        });

        /*--------------------- 
        for len 1 convertPointsToSVGPath() gives error so points duplicated to make len > 1 
        so when remote user just make dot it will work even if it will have point len = 1 */
        if (this.freeDrawPoints.length == 1) {
            this.freeDrawPoints.push(new fabric.Point(stpointx, stpointy));
        }

        /*-------------------*/
        if (this.freeDrawPoints.length > 1 && msg.pointStatus === "3") {
            this.addPencilPathFromPoints(liveclor, msg);
        }
    };

    drawonlive = (msg) => {
        LogFirebase("Markup", "received_msg_shape_type", msg.shape_type + "::" + msg.status);
        let shape_type = "1"; // default free draw
        if (msg.shape_type != null) {
            shape_type = msg.shape_type;
        }
        //// Commented to fix high resoultion annotation bug - Rama pc
        //// let canvas = document.getElementById('outcanvas').getElementsByClassName("upper-canvas")[0];
        if (msg.status == shapeStatus.UNDO || msg.status == shapeStatus.REDO) {
            this.selectShapeAction(msg);
            if (this.objExistOnCanvas()) {
                enableSaveMarkup();
            }
            return;
        }

        if (shape_type == SHAPE_TYPE.FREEDRAW && !reduxStore.getState().markup.markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
            this.managePencilPoints(msg);
        } else {
            this.selectShapeAction(msg);
            enableSaveMarkup();
        }
    };

    /** prepares text annotation and calls from enter key or from click anywhere on canvas */
    preparTextAnnotation = (txtObj, shapeStatus) => {
        console.log(`isresetted: ${this.isresetted}, escape: ${this.escape}`);

        // No message needs to be sent if the textbox is empty, reset, or escape is triggered
        if (this.isresetted || this.escape || this.isTextBoxEmpty(txtObj)) {
            return false;
        }

        // Prepare annotation message
        const annMsg = {
            XPOINTS_START: txtObj.left, // Textbox left position
            YPOINTS_START: txtObj.top, // Textbox top position
            HEIGHT: this.annCanvas.getHeight(),
            WIDTH: this.annCanvas.getWidth(),
            TextContainerWidth: parseFloat(txtObj.width),
            TextContainerHeight: parseFloat(txtObj.height),
            COLOR: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
        };

        // Prepare text details
        const txtDetails = {
            text_str: txtObj.text,
            font_size: txtObj.fontSize.toString(),
        };

        // Prepare annotation points message array
        const annmsgpoints = [annMsg];

        // Discard the active object and render the canvas
        this.annCanvas.discardActiveObject();
        this.annCanvas.renderAll();

        // Send annotation points message
        this.sendAnnotationPointsMsg(txtObj.id, annmsgpoints, SHAPE_TYPE.TEXT, shapeStatus, txtDetails);
    };

    changeText = (newText, txtObj) => {
        // Select all text in the object
        txtObj.selectAll();

        // Update the text in the object
        txtObj.text = newText;
        txtObj.hiddenTextarea.value = newText;
        txtObj.dirty = true;

        // Recalculate the object's coordinates
        txtObj.setCoords();

        // Render the updated canvas
        this.annCanvas.renderAll();
    };

    formatNewLineText = (txtObj) => {
        let formattedText = "";
        if (txtObj.text.length > 18) {
            formattedText = txtObj.text.substr(0, 18) + "\n" + txtObj.text.substr(18, txtObj.text.length);
        } else {
            formattedText = txtObj.text;
        }
        return formattedText;
    };

    getColorForNewJoinee = (identity) => {
        let added = false;
        let colorsToDraw = { ...reduxStore.getState().markup.assignedColors };

        COLOR_TO_ANNOT.forEach((color) => {
            if (!added) {
                if (color !== AGENT_DEFAULT_COLOR && !Object.values(colorsToDraw).includes(color)) {
                    colorsToDraw[identity] = color;
                    reduxStore.dispatch(setAssignedColors(colorsToDraw));
                    console.log("Assigned colors:", colorsToDraw);
                    added = true;
                }
            }
        });

        return colorsToDraw[identity];
    };

    /**removes assigned color when participant gets disconnected */
    removeAssignedColor = (identity) => {
        const assignedColors = reduxStore.getState().markup.assignedColors;
        if (assignedColors.hasOwnProperty(identity)) {
            const updatedColors = { ...assignedColors };
            delete updatedColors[identity];
            reduxStore.dispatch(setAssignedColors(updatedColors));
        }
    };

    /* Handle new joinee for markup */
    handleNewJoineeForMarkup = (identity) => {
        const { markupLiveStream, arMarkupLiveStream } = reduxStore.getState().markup;
        // Determine the color for the new joinee
        if (
            reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW ||
            markupLiveStream ||
            arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW
        ) {
            const { deviceType, oppOrientation } = reduxStore.getState().commonReducer.OppoDetails;
            const id = identity;
            const colorForNewJoinee = this.getColorForNewJoinee(identity);
            console.log("Color for new joinee: ===>", colorForNewJoinee);

            // Construct the message for the new joinee
            const msg = {
                identity: CALL_DATA.localIdentity,
                for_new_joinee: {
                    [id]: colorForNewJoinee,
                },
                device_type: deviceType || "3",
                orientation: oppOrientation, // opponent
            };

            // Handle notification type for markup live stream
            if (markupLiveStream) {
                msg.notification_type = NOTIFICATION_TYPES.MARKUP_LIVESTREAM.AGENT_TO_ALL;
            } else if (arMarkupService.checkARMarkupIsOngoing() && arMarkupService.ARMarkupStarted && !dualStreamEnabled()) {
                setTimeout(() => {
                    arMarkupService.commonFuncForSendingARStatusDataTrack(arMarkupService.arMarkupStatus.started, "from_new_joinne", identity);
                }, 2000);
            } else {
                msg.notification_type = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT;
                msg.status = this.dataTrackStatus.uploadImageComplete;
                msg.image_url = this.annImgURL;
            }
            console.log("OppoDetails_handleNewJoineeForMarkup_msg", msg);

            // Send the message to the appropriate recipient
            sendDataTrack(msg);
        }
    };

    /**undo local objects */
    undoLocalObject = () => {
        // Ensure local shapes list is prepared
        if (this.localShapesList && this.localShapesList.length === 0) {
            this.prepareLocalShapesList();
        }

        // Proceed if there are items in the local shapes list
        if (this.localShapesList && this.localShapesList.length > 0) {
            // Log the UNDO event
            googleEvent.logEvent(EVENT_NAME.UNDO_TAPPED);

            // Get the latest object and remove it from the local shapes list
            const latestObj = this.localShapesList.pop();

            // Check if markup live streams are inactive
            const { markupLiveStream } = reduxStore.getState().markup;
            if (!markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
                // Remove the latest object from the annotation canvas
                this.annCanvas.remove(latestObj);
            }

            // Add the latest object to the local undo list
            this.localUndoList.push(latestObj);

            // Decrease arrow count if the latest object is an arrow
            if (latestObj.shape_type === SHAPE_TYPE.ARROW) {
                this.increaseDecreaseArrowCount("decrease");
            }

            // Log the updated undo list for debugging
            console.log("Undo object:");
            console.log(this.localUndoList);

            // Prepare and send annotation points message
            const annMsgPoints = [];
            this.sendAnnotationPointsMsg(latestObj.id, annMsgPoints, latestObj.shape_type, shapeStatus.UNDO);

            // Enable or disable undo button based on the canvas content
            if (!this.localObjExistOnCanvas()) {
                disableMarkupUndo();
            } else {
                enableMarkupUndo();
            }

            // Enable the redo button
            enableMarkupRedo();
        }
    };

    /**redo local objects */
    redoLocalObject = () => {
        if (this.localUndoList && this.localUndoList.length > 0) {
            // Log the REDO event
            googleEvent.logEvent(EVENT_NAME.REDO_TAPPED);

            // Get the last undone object
            const obj = this.localUndoList[this.localUndoList.length - 1];

            // Check if markup live streams are inactive
            const { markupLiveStream } = reduxStore.getState().markup;
            if (!markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
                // Add the object back to the annotation canvas
                this.annCanvas.add(obj);
            }

            // Move the object from the undo list to the shapes list
            this.localShapesList.push(obj);
            this.localUndoList.pop();

            // Increase arrow count if the object is an arrow
            if (obj.shape_type === SHAPE_TYPE.ARROW) {
                this.increaseDecreaseArrowCount(INCREASE);
            }

            // Log the updated undo list for debugging
            console.log("Undo object: =====>", this.localUndoList);

            // Prepare annotation points message
            const annMsgPoints = [];
            this.sendAnnotationPointsMsg(obj.id, annMsgPoints, obj.shape_type, shapeStatus.REDO);

            // Disable the undo button if there are no more items to redo
            if (this.localUndoList.length === 0) {
                disableMarkupRedo();
            }

            // Enable the undo button
            enableMarkupUndo();
        }
    };

    /** Undo the remote object by object ID */
    undoRemoteObject = (data) => {
        // Retrieve the object by its ID
        const obj = this.getObjectById(data.objectid);
        console.log("Last object for remote undo: =====>", obj);

        if (obj) {
            // Add the object to the remote undo list
            this.remoteUndoList.push(obj);

            // Check if markup live streams are inactive
            const { markupLiveStream } = reduxStore.getState().markup;
            if (!markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
                // Remove the object from the annotation canvas and render
                this.annCanvas.remove(obj);
                this.annCanvas.renderAll();
            }

            // Log the updated remote undo list for debugging
            console.log("Undo remote object:", this.remoteUndoList);
        }
    };

    /** Redo the remote object by object ID */
    redoRemoteObject = (data) => {
        const { markupLiveStream } = reduxStore.getState().markup;

        // Iterate over the remote undo list to find the object by ID
        this.remoteUndoList.forEach((canvasObj, index) => {
            if (canvasObj && canvasObj.id == data.objectid) {
                // as getting object id in string from the notification
                // Check if markup live streams are inactive
                if (!markupLiveStream && !arMarkupService.checkARMarkupIsOngoing()) {
                    // Add the object back to the annotation canvas
                    this.annCanvas.add(canvasObj);
                }

                // Log the object being redone
                console.log("Redo remote object:  =====>", canvasObj);

                // Remove the object from the remote undo list
                this.remoteUndoList.splice(index, 1);

                // Log the updated remote undo list for debugging
                console.log("redo remote object:", this.remoteUndoList);
            }
        });
    };

    // Handle increase or decrease of arrow counts
    increaseDecreaseArrowCount = (action) => {
        switch (action) {
            case INCREASE:
                this.numberOfCountForARMarkupArrow += 1; // Increase arrow count
                break;
            case DECREASE:
                this.numberOfCountForARMarkupArrow -= 1; // Decrease arrow count
                break;
            default:
                this.numberOfCountForARMarkupArrow = 0; // Reset arrow count
                break;
        }
        console.log("Arrow count updated: =====>", action, this.numberOfCountForARMarkupArrow);
    };

    // Handle markup live stream request - 1503 datatrack
    handleMarkupLiveStreamRequestToStreamingUser = (msg) => {
        console.log("handleMarkupLiveStreamRequest", msg);
        if (PublicVariables.featureFlag?.SHOWMELIVEANNOTATION !== ENABLED) {
            return;
        }
        if (!arMarkupService.checkARMarkupIsOngoing()) {
            reduxStore.dispatch(setMarkupLiveStream(true));
            LogFirebase("Markup", "received_msg_start_markup", "Agent Started Markup Live Stream");
            if (PublicVariables.isMobile) {
                zoomService.disablepinchOnmarkup = true; // to check mark up is on
                zoomService.disablePinchZoom(); // disable pinch zoom
            }
            this.setAnnoteColor(msg);
            if (GLOBAL_MEETING_DATA.isGuest) {
                // on reconnect reset the thickness
                reduxStore.dispatch(setSelectedThicknessForShape(SHAPE_THICKNESS[5])); // 10px
                reduxStore.dispatch(setSelectedFontSizeForShape(FONT_SIZE[7])); // 30px
            }
            reduxStore.dispatch(setIsShadowOrStroke(true)); // default shadow is on
            this.startMarkupLiveStream();
        }
    };

    exitMarkupLiveStream = (identity, sendNoti) => {
        let fromNoti = true;
        if (sendNoti) {
            fromNoti = false;
        }
        LogFirebase("Markup", "LiveStream-received_msg_stopped_markup", "Markup stopped by " + identity);
        this.increaseDecreaseArrowCount();
        if (reduxStore.getState().markup.callannview || reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW) {
            if (GLOBAL_MEETING_DATA.isAgent) {
                extractTextService.showExitMarkUpOCRToast("Markup", identity);
                this.toggleannotationdiv(fromNoti, false, true);
            } else {
                this.toggleannotationdiv(true, false, true);
            }
        } else {
            //do not perform anything
        }
    };

    handleMarkupLiveStreamSavedStatus = (msg) => {
        if (msg.uploadStatus == "1") {
            takePhotoService.addThumbInList(msg.thumbUrl, msg.fileUrl, msg.fileName);
            this.uploadingCount = 0;
            this.uploadedCount = 0;
            extractTextService.showToastMessage(
                Localize[PublicVariables.currentLanguageObj?.languageCode]["successfully_uploaded"],
                false,
                this.saveImageToastId
            );
            setTimeout(() => {
                extractTextService.dismissAgentToast(this.saveImageToastId);
            }, 2000);
            LogFirebase("Markup", "LiveStream_saved_by_agent", "Markup UPLOADED");
        } else {
            this.uploadingCount = this.uploadingCount - 1;
            extractTextService.dismissAgentToast(this.saveImageToastId);
            CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_failed"]);
            LogFirebase("Markup", "LiveStream_save_failed", "Markup UPLOAD FAILED");
        }
    };

    /**android app sends back save marked up image's status */
    handleSaveMarkupStatus = (msg) => {
        if (msg.uploadStatus == this.dataTrackStatus.uploadImageStart) {
            if (msg.thumbURL && msg.image_url) {
                let obj = {
                    thumbUrl: msg.thumbURL,
                    fileUrl: msg.image_url,
                    fileName: msg.imageName,
                    uploadStatus: msg.uploadStatus,
                };
                this.handleMarkupLiveStreamSavedStatus(obj);
            } else {
                console.error("NO Thumb URL or Image URL in save status");
                LogFirebase("Markup", "LiveStream-save-status", "NO thumb or Image URL");
            }
        } else {
            this.handleMarkupLiveStreamSavedStatus({ uploadStatus: msg.uploadStatus });
            CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["upload_failed"]);
        }
    };

    stopMarkupHandler = (msg) => {
        LogFirebase("Markup", "LiveStream-received_msg_stopped_markup", "Markup stopped by " + msg.identity);
        if (reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW) {
            extractTextService.cancelMarkUpOCRPreparing("ARMarkup");
        }
        if (msg.notification_type == NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT && GLOBAL_MEETING_DATA.isGuest) {
            CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["ar_live_streaming_marking_stopped"]);
        }
        zoomService.disablepinchOnmarkup = false;
        this.exitMarkupLiveStream(msg.identity);
    };

    handleMarkupLiveStreamRequestFromStreamingUser = (msg) => {
        if (PublicVariables.featureFlag?.SHOWMELIVEANNOTATION !== ENABLED) {
            return;
        }
        if (msg.identity !== CALL_DATA.localIdentity) {
            const { dataTrackStatus } = this;
            switch (msg.status.toString()) {
                case dataTrackStatus.stopMarkup: // stop live stream markup
                    this.stopMarkupHandler(msg);
                    break;
                case dataTrackStatus.clearMarkup: //clear live stream markup
                    LogFirebase("Markup", "LiveStream-received_msg_clear", "Markup cleared clicked by " + msg.identity);
                    this.clearImg(false); // clear all is not clicked and coming from notification then don't send msg to any other user
                    break;
                case dataTrackStatus.saveFromAndroidApp: //save staus from android app
                    if (GLOBAL_MEETING_DATA.isAgent) {
                        LogFirebase("Markup", "LiveStream-received_save_status", "upload status: " + msg.uploadStatus);
                        this.handleSaveMarkupStatus(msg);
                    }
                    break;
                case dataTrackStatus.cancleMarkup: //request to cancel ARmarkup
                    extractTextService.cancelMarkUpOCRPreparing("ARMarkup");
                    break;
                case dataTrackStatus.appRunningInbackground:
                    this.handleAppRunningInBackground();
                    break;
                case dataTrackStatus.appRunningInForeground:
                    this.handleAppRunningInForeground();
                    break;
                default:
                    console.log("default case");
                    break;
            }
        }
    };

    handleAppRunningInBackground = () => {
        this.allShapeDisable = true;
        reduxStore.dispatch(setAllShapeDisable(true)); // disable save button when app foreground during ARMarkup
        this.freeway = false;
        this.annCanvas.isDrawingMode = false;
        CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["video_paused"]);
        if (this.annCanvas) {
            // clear local shape when bg datatrack received
            this.annCanvas.clear();
        }
    };

    handleAppRunningInForeground = () => {
        this.allShapeDisable = false;
        reduxStore.dispatch(setAllShapeDisable(false)); // enable save button when app foreground during ARMarkup
        if (this.shape == SHAPE_TYPE.FREEDRAW) {
            this.freeway = false;
            this.annCanvas.isDrawingMode = true;
        }
    };

    handleOnEscapeKey = () => {
        const markupInprogress = reduxStore.getState().markup.markupInprogress;
        if (markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
            // mark up is running
            let activeObj = this.annCanvas.getActiveObject();

            if (activeObj != null) {
                if (activeObj.shape_type == SHAPE_TYPE.TEXT) {
                    this.escape = true;
                    this.annCanvas.remove(activeObj);
                }
            }
        }
        //// if($scope.bookmarkSrch.text){ // if bookmark is searched
        ////     $scope.bookmarkSrch.text = '';
        //// }
        //// call settings pop up
        //// $scope.callSettingModelClose();
        //// on escape event mediate popup will be close
        //// $scope.confirmMediateTheCall = false;
    };
    //handle all ctrl+z
    handleControlZkey = () => {
        //for markup undo
        const markupInprogress = reduxStore.getState().markup.markupInprogress;
        if (markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
            // mark up is running
            this.undoLocalObject();
        }
    };
    //handle all ctrl+y
    handleControlYkey = () => {
        const markupInprogress = reduxStore.getState().markup.markupInprogress;
        if (markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
            // mark up is running
            this.redoLocalObject();
        }
    };
}

export default new MarkupService();
